<template>
  <div class="acitvityAll">
    <div class="backBox" style="padding-top: 20px;border-bottom: 0">
       <jd-back @back="toSetting()" :title="['活动管理']" subTitle="数据统计"></jd-back>
    </div>
    <div class="actName">
      <img
        class="actName_img"
        src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/common/icon_lw.png"
        style="margin-right: 20px"
        alt=""
      />
      <div class="actName_info">
        <span>活动名称：{{ rowData.activityName }}</span>
        <div v-if="fitersChooseIF([35], '!=')">
          活动时间：{{ rowData.startTime }} 至 {{ rowData.endTime }}
        </div>
        <div v-if="fitersChooseIF([32,56,57])">
          计划类型：{{rowData.activityType == 32 ? '会员卡片' : rowData.activityType == 56? '活动部件（小）':"活动部件（大）"}}
        </div>
        <template v-else-if="rowData.ruleDto">
          <div>
            确权时间：{{ rowData.ruleDto.lockStartTime }} 至
            {{ rowData.ruleDto.lockEndTime }}
          </div>
          <div>
            下单时间：{{ rowData.ruleDto.orderStartTime }} 至
            {{ rowData.ruleDto.orderEndTime }}
          </div>
          <div>
            确认收货时间：{{ rowData.ruleDto.finishStartTime }} 至
            {{ rowData.ruleDto.finishEndTime }}
          </div>
        </template>
      </div>
    </div>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      class="formSty"
    >
      <!-- 后端暂不做活动统计，前端需改逻辑隐藏，包括初始化逻辑 -->
      <el-tab-pane label="活动统计" name="first">
        <div class="section-right-content-box">
          <div style="margin: 20px 0px 20px 0px">
            <jd-form 
              :form-info="myFormInfo"
              :formData.sync="queryForm"
              @search="querySeach"
              :emitReset="true"
              :btn30="true"
              ref="statiscFormRef"
              @reset="queryOne()">
              <template #evaluateTime>
                <div class="flex-box">
                  <jd-radio
                    :recentList="options.evaluateTimeOpt"
                    :defaultIndex="defaultIndex"
                    @change="timeChange"
                  />
                  <div class="my_select_time">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="postForm.startDate"
                      type="date"
                      :placeholder="'选择日期时间'"
                      size="small"
                      :disabled="
                        queryForm.evaluateTime != 0 || !queryForm.evaluateTime
                      "
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      style="width: 120px; font-size: 12px"
                      class="time1"
                      :clearable="false"
                    ></el-date-picker>
                    <div
                      class="time_to_text"
                      :class="{
                        to_text_disabled:
                          queryForm.evaluateTime != 0 || !queryForm.evaluateTime,
                      }"
                    >
                      至
                    </div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="postForm.endDate"
                      type="date"
                      :placeholder="'选择日期时间'"
                      size="small"
                      :disabled="
                        queryForm.evaluateTime != 0 || !queryForm.evaluateTime
                      "
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      style="width: 145px; font-size: 12px"
                      class="time2"
                      :clearable="true"
                    ></el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      @click="clearTimeSendTime()"
                    ></i>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                      alt
                      class="date_icon2"
                    />
                  </div>
                </div>
              </template>
            </jd-form>
            <!-- 积分确权定制特殊处理 -->
            <div class="pt-16 bg-F8F9FA pl-40" v-if="fitersChooseIF([35])">
              <span>投放渠道：</span>
              <el-select
                size="small"
                v-model="postForm.channelCode"
                style="width: 280px"
              >
                <el-option
                  v-for="(item, index) in batchTypeList"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
              <jd-button
                class="float-r"
                width="80px"
                style="margin-left: 6px"
                @click="export_get"
                type="text"
                v-preventReClick
                > 导出</jd-button
              >
            </div>
            <!-- 打榜有礼导出功能 -->
             <div class="export-box" v-if="fitersChooseIF([36])">
              <jd-button type="text" width="80px" @click="export_get">导出</jd-button>
            </div>
            <!-- 派样回购礼导出功能 -->
             <div class="export-box pb-16" v-if="fitersChooseIF([37])">
              <jd-button type="text" width="80px" @click="export_get">导出</jd-button>
            </div>
          </div>
          <div class="background data-title-wrap" v-if="fitersChooseIF([32,56,57], '!=')">
            <jd-title label='转化分析'></jd-title>
            <span class="back_text" @click="triggerVersion">返回新版</span>
          </div>
          <!-- 下单转化 -->
          <div
            v-if="fitersChooseIF([35])"
            style="font-size: 12px; margin-bottom: 4px; color: #999"
          >
            * 该数据不区分渠道
          </div>
          <div class="titClass" v-if="fitersChooseIF([25, 26, 32, 33,56,57], '!=')">
            <div class="down">
              下单转化
              <el-popover
                placement="top-start"
                width="400"
                offset="100"
                trigger="hover"
                data-html="true"
              >
                <span>转化数据说明：</span><br />
                <span> 1、人群:参与活动的用户。</span><br />
                <span>
                  2、时间:活动开始至T+1
                  (昨日)的累计成交数据，每天中午12:30后更新。</span
                ><br />
                <span>
                  3、订单维度:已付款的在线支付订单或者选择货到付款的订单。</span
                ><br />
                <span>
                  4、备注:活动结束后15天内的数据都可以统计，超过15天的数据将无法统计。</span
                ><br />
                <span>
                  5、由于京东数据的限制，活动开始和结束时间只能以活动首次创建的时间为准;中途修改活动时间，无法更新转化数据的统计时间范围。</span
                ><br />
                <span class="new-icon-box" slot="reference"></span>
                <!-- <span style="float: right" slot="reference">
                  <p class="question_iconOne">?</p>
                </span> -->
              </el-popover>
            </div>
            <div class="borderU"></div>
            <div
              class="titClassOne"
              v-for="(v, index) in hostList"
              :key="index"
            >
              <div style="color: #333333; font-size: 14px">
                {{ v.name }}
              </div>
              <div style="color: #1F1F1F; font-size: 18px; font-weight: 600;">
                {{
                  index == 0
                    ? tatal_num.users
                    : index == 1
                    ? tatal_num.ordNum
                    : index == 2
                    ? tatal_num.gmv
                    : (tatal_num.ordRate * 100).toFixed(2)
                }}
                <span style="color: #999999; font-size: 14px">
                  {{
                    index == 0
                      ? "人"
                      : index == 1
                      ? "单"
                      : index == 2
                      ? "元"
                      : "%"
                  }}
                </span>
              </div>
            </div>
          </div>
          <div class="background">
            <jd-title label='数据总览'></jd-title>
          </div>
          <div style="position: relative;">
            <jd-loading-new v-if="loading" :overlay="true" />
            <div
              :class="fitersChooseIF([36]) ? 'overview2' : 'overview1'"
              style="float: left"
              v-for="(item, index) in dataSummary"
              :key="index + item.value"
              :style="
                item.value == 'successfulParticipants'
                  ? { width: '25%' }
                  : item.value == 'sharePeoNum'
                  ? { width: '10%', 'border-right': '0px' }
                  : {}
              "
            >
              <div>
                <span class="fontClass">{{ item.name }}</span>
                <el-popover
                  v-if="item.tipsName"
                  placement="top-start"
                  offset="100"
                  trigger="hover"
                  :content="item.tipsName"
                >
                <span class="new-icon-box" style="margin-left: 5px;" slot="reference"></span>
                </el-popover>
              </div>
              <div class="num">
                {{ tableTotal[item.value] }}{{fitersChooseIF([25, 26, 32, 33,56,57]) 
                  &&
                  (item.value == 'orderRate' || item.value == 'cartRate' || item.value == 'clickRate' || item.value == 'payOrderRate' || item.value == 'visitUsrPayOrderRate') ? 
                  '%':'' }}{{fitersChooseIF([37]) 
                  &&
                  (item.value == 'enterReBuyRate' || item.value == 'orderReBuyRate') ? 
                  '%':''}}
              </div>
            </div>
          </div>
          <!-- 折线图 -->
          <div
            style="clear: left; position: relative;"
            ref="payRemindChart"
            class="chart"
          >
            <jd-loading-new v-if="loading" :overlay="true" />
          </div>
          <div class="new-table-box" style="margin-top: 20px">
            <jdTable
              :tableData="activityTable"
              :tableInfo="initTableColumns()"
              :pageInfo="{
                pageNum: formList.current,
                pageSize: formList.size,
                total: totalNum
              }"
              @handlePage="handlePage"
              :loading="loading"
              style="width: 100%;"
            >
              <!-- dateTime时间显示插槽 - 当dateTime为null时显示合计 -->
              <template #dateTime="{ row }">
                <span>{{ row.dateTime || '合计' }}</span>
              </template>
              
              <!-- 活动参与统计插槽 -->
              <template #participateStats="{ row }">
                <div v-if="fitersChooseIF([32,56,57])">
                  <span>访客数:{{ row.onlineUv }} </span>
                  <span>点击用户数:{{ row.uv }} </span>
                  <span>点击次数:{{ row.pv }} </span>
                </div>
                <div v-else>
                  <span>参与人数:{{ row.joinNumber }} </span>
                  <span>参与人次:{{ row.joinTimes }} </span>
                  <span>新增人数:{{ row.incrFollowNumber }} </span>
                </div>
              </template>
              
              <!-- 奖品统计插槽 -->
              <template #prizeStats="{ row }">
                <span v-if="row.aqy != null">
                  爱奇艺会员:{{ row.aqy }}个
                </span>
                <span v-if="row.beans != null">
                  京豆:{{ row.beans }}个
                </span>
                <span v-if="row.coupon != null">
                  优惠券:{{ row.coupon }}张
                </span>
                <span v-if="row.eCard != null">
                  E卡:{{ row.eCard }}张
                </span>
                <span v-if="row.goods != null">
                  实物:{{ row.goods }}件
                </span>
                <span v-if="row.plus != null">
                  PLUS会员:{{ row.plus }}个
                </span>
                <span v-if="row.redPacket != null">
                  红包:{{ row.redPacket }}元
                </span>
                <span v-if="row.scores != null">
                  积分:{{ row.scores }}积分
                </span>
              </template>
            </jdTable>
          </div>
        </div>
      </el-tab-pane>
      <!-- 派样付款列表 -->
      <el-tab-pane label="派样付款列表" name="sendReBuyPay" v-if="fitersChooseIF([37])">
        <jd-form
          :formInfo="inputSendBuyPayFormInfo"
          @search="searchSendBuyPay"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          style="float: right; margin-bottom: 20px"
          @click="export_get"
          type="text"
          v-preventReClick
          >导出</jd-button
        >
        <jdTable
          :tableData="sendBuyPayTable"
          :tableInfo="sendBuyPayTableColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalSendBuyPayCount
          }"
          @handlePage="handleSendBuyPayPage"
          :loading="loading"
          style="width: 100%; margin: 40px auto"
        >
          <!-- 商品信息插槽 -->
          <template #shopNameDetail="{ row }">
            <div>{{ row.skuName }}</div>
          </template>
          <!-- 是否录入收货信息插槽 -->
          <template #isCommitAddress="{ row }">
            <div>{{ row.isCommitAddressStr }}</div>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 入会用户转化分析 -->
      <el-tab-pane label="入会用户转化分析" name="conversionAnalysis"  v-if="fitersChooseIF([32])">
        <div class="conversion">
          <jd-tip>
            <div>
              分析在本次活动入会的粉丝在一段时间内的转化数据，转化数据不区分订单类型及不排除本次活动下单的订单，仅2024-11-12
              后创建的活动支持
            </div>
          </jd-tip>
        </div>
        <jd-form
          :form-info="inputConversionInfo"
          @search="searchConversionFun"
          :emitReset="true"
          :btn30="true"
          @reset="resetConversionFun"
          ref="export_funRef"
          class="mt16 mb16"
        >
          <template slot="statDaysNum">
            <el-input
              placeholder="请输入"
              v-model="conversionForm.statDaysNum"
              class="conversion-statDaysNum"
              @input="
                conversionForm.statDaysNum = getNumberData(1, $event, 0, 1, 30)
              "
            >
              <span slot="suffix">天</span>
            </el-input>
            <span style="font-size: 12px;color: #333333;font-weight: 500;"> 内的订单</span>
          </template>
          <template slot="orderMoney">
            <el-select
              v-model="conversionForm.statType"
              class="conversion-statType"
            >
              <el-option label="累计下单金额(付款)" :value="0"></el-option>
              <el-option label="累计下单金额(成交)" :value="1"></el-option>
            </el-select>
            <el-select
              v-model="conversionForm.compareType"
              class="conversion-compareType"
            >
              <el-option label="大于等于" :value="0"></el-option>
              <el-option label="小于等于" :value="1"></el-option>
            </el-select>
            <el-input
              placeholder="请输入"
              v-model="conversionForm.orderAmount"
              class="conversion-orderMoney"
              @input="
                conversionForm.orderAmount = getNumberData(
                  1,
                  $event,
                  0,
                  1,
                  999999
                )
              "
            ></el-input>
          </template>
        </jd-form>
        <jd-button
          class="mb12"
          :disabled="conversionData.length == 0"
          @click="addCrowd(18)"
          >按查询结果生成人群</jd-button
        >
        <jd-table
          :loading="loading"
          :tableData="conversionData"
          :pageInfo="{
            pageNum: conversionPage.current,
            pageSize: conversionPage.size,
            total: conversionPage.total,
          }"
          @handlePage="handlePageConversion"
        >
          <el-table-column prop="chaosPin" label="用户Pin"></el-table-column>
          <el-table-column prop="memberNick" label="用户昵称"></el-table-column>
          <el-table-column prop="sellerLinkName" label="投放渠道" v-if="fitersChooseIF([46,19])"></el-table-column>
          <el-table-column prop="openCardTime" label="入会时间">
          </el-table-column>
          <el-table-column prop="payOrderNum" label="下单订单数" align="right">
          </el-table-column>
          <el-table-column
            prop="commitOrderNum"
            label="成交订单数"
            align="right"
          >
          </el-table-column>
          <el-table-column
            prop="statPayOrderAmount"
            label="累计下单金额(付款)"
            align="right"
          >
          </el-table-column>
          <el-table-column
            prop="statDealOrderAmount"
            label="累计下单金额(成交)"
            align="right"
          >
          </el-table-column>
          <el-table-column
            prop="avgPayOrderAmount"
            label="客单价(付款)"
            align="right"
          >
          </el-table-column>
        </jd-table>
      </el-tab-pane>

      <!-- 回购付款列表 -->
      <el-tab-pane label="回购付款列表" name="sendReBuyRePay" v-if="fitersChooseIF([37])">
        <jd-form
          :formInfo="inputSendBuyRePayFormInfo"
          @search="searchSendBuyRePay"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          style="float: right; margin-bottom: 20px"
          @click="export_get"
          type="text"
          v-preventReClick
          >导出</jd-button
        >
         <jdTable
          :tableData="sendBuyRePayTable"
          :tableInfo="sendBuyRePayTableColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalSendBuyRePayCount
          }"
          @handlePage="handleSendBuyRePayPage"
          :loading="loading"
          style="width: 100%; margin: 40px auto"
        >
          <!-- 商品信息插槽 -->
          <template #shopNameDetail="{ row }">
            <div>{{ row.skuName }}</div>
          </template>
          <!-- 是否录入收货信息插槽 -->
          <template #isCommitAddress="{ row }">
            <div>{{ row.isCommitAddressStr }}</div>
          </template>
          <!-- 是否中奖插槽 -->
          <template #isWin="{ row }">
            <div>{{ row.isWin == 1 ? '是': '否' }}</div>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 积分锁权-参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="lockJoinRecord"
        v-if="fitersChooseIF([45])"
      >
        <jd-form
          :formInfo="inputParticipatLockFormInfo"
          @search="searchParticipationLockForm"
          style="margin: 20px 0"
        ></jd-form>
        <div class="flex-spc-x">
          <jd-button
            type="break"
            style="margin-bottom: 16px;"
            @click="addCrowd(26)"
            >按查询结果生成人群</jd-button
          >
          <jd-button
            type="text"
            @click="exportFn"
            v-preventReClick
            >导出</jd-button
          >
        </div>
        <jdTable
          :tableData="ParticipatLockTable"
          :tableInfo="participatLockTableColumns"
          :pageInfo="{
            pageNum: formListLock.current,
            pageSize: formListLock.size,
            total: totalParticipatLock
          }"
          @handlePage="handleParticipatLockPage"
          :loading="loading"
        >
          <!-- 是否符合中奖条件插槽 -->
          <template #isPass="{ row }">
            <span>
              {{
                row.isPass == 1
                  ? "符合"
                  : row.isPass == 0
                  ? "不符合"
                  : "-"
              }}
            </span>
          </template>
          <!-- 是否领取奖品插槽 -->
          <template #isWin="{ row }">
            <span v-if="row.isWin == 1" class="green-status-icon"></span>
            <span v-if="row.isWin == 0" class="yellow-status-icon"></span>
            <span>
              {{
                row.isWin == 1
                  ? "已领取"
                  : row.isWin == 0
                  ? "未领取"
                  : "-"
              }}
            </span>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="eleven"
        v-if="fitersChooseIF([23, 24])"
      >
        <jd-form
          :formInfo="inputParticipatFormInfo"
          @search="searchParticipationForm"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="margin-bottom: 16px;"
          @click="addCrowd(6)"
          >按查询结果生成人群</jd-button
        >
        <jdTable
          :tableData="ParticipatTable"
          :tableInfo="initParticipatTableColumns()"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalParticipat
          }"
          @handlePage="handleParticipatPage"
          :loading="loading"
        >
          <!-- 得分插槽 -->
          <template #score="{ row }">
            <span>
              {{
                row.score || row.score == 0
                  ? row.score
                  : "--"
              }}
            </span>
          </template>
          <!-- 是否通关插槽 -->
          <template #isPass="{ row }">
            <span>
              {{
                row.isPass == 1
                  ? "是"
                  : row.isPass == 0
                  ? "否"
                  : "--"
              }}
            </span>
          </template>
          <!-- 是否抽奖插槽 -->
          <template #isDraw="{ row }">
            <span>
              {{
                row.isDraw == 1
                  ? "是"
                  : row.isDraw == 0
                  ? "否"
                  : "--"
              }}
            </span>
          </template>
          <!-- 是否中奖插槽 -->
          <template #isWin="{ row }">
            <span>
              {{
                row.isWin == 1
                  ? "是"
                  : row.isWin == 0
                  ? "否"
                  : "--"
              }}
            </span>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 签到纪录 -->
      <el-tab-pane label="签到记录" name="second" v-if="fitersChooseIF([1])">
         <jd-form
          :formInfo="inputSignInFormInfo"
          @search="searchForm"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="margin-bottom: 16px;"
          @click="addCrowd(1)"
          >按查询结果生成人群</jd-button
        >
        <jdTable
          :tableData="signInTable"
          :tableInfo="signInTableColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalSignIn
          }"
          @handlePage="handleSignInPage"
          :loading="loading"
        >
        </jdTable>
      </el-tab-pane>

      <!-- 预约记录 -->
      <el-tab-pane label="预约记录" name="fifteen" v-if="fitersChooseIF([33])">
        <jd-form
          :formInfo="inputReservationFormInfo"
          @search="searchFormThir2"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="margin-bottom: 16px;"
          @click="addCrowd(13)"
          >按查询结果生成人群</jd-button
        >
        <jdTable
          :tableData="exchangeList"
          :tableInfo="reservationTableColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalMail
          }"
          @handlePage="handleReservationPage"
          :loading="loading"
        >
          <!-- 中奖状态插槽 -->
          <template #isWin="{ row }">
            <span v-if="row.isWin == 1"><span class="green-status-icon"></span>已中奖</span>
            <span v-if="row.isWin == 0"><span class="red-status-icon"></span>未中奖</span>
            <span v-if="row.isWin == 2"><span class="yellow-status-icon"></span>待开奖</span>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 加购记录 -->
      <el-tab-pane
        label="加购记录"
        name="thirtyFour"
        v-if="fitersChooseIF([34])"
      >
        <jd-form
          :formInfo="inputDataAddCartFormInfo"
          @search="searchAddCart"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="margin-bottom: 16px;"
          @click="addCrowd(2)"
          >按查询结果生成人群</jd-button
        >
        <jdTable
          :tableData="addCartTable"
          :tableInfo="addCartTableColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalAddCart
          }"
          @handlePage="handlePageAddCart"
          :loading="loading"
        >
          <!-- 是否满足领奖条件插槽 -->
          <template #isAllowGetPrize="{ row }">
            <span>{{ row.isAllowGetPrize ? "满足" : "不满足" }}</span>
          </template>
          <!-- 是否中奖插槽 -->
          <template #isWin="{ row }">
            <span :class="row.isWin?'green-status-icon':'red-status-icon'"></span>
            <span>{{ row.isWin ? "已中奖" : "未中奖" }}</span>
          </template>
          <!-- 操作插槽 -->
          <template #action="{ row }">
            <jd-button type="blueText" @click="checkCartDetail(row)"
              >查看详情</jd-button
            >
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 锁权记录 -->
      <el-tab-pane label="锁权记录" name="eighteen" v-if="fitersChooseIF([35])">
        <jd-form
          :formInfo="inputLockRightFormInfo"
          ref="export_fun18"
          @search="searchLockRight"
          style="margin: 20px 0"
        ></jd-form>
        <input-form
          :inputData="inputLockRight"
          ref="export_fun18"
          @toParentVal="searchLockRight"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form>
        <jd-button
          style="float: right; margin-bottom: 20px"
          type="text"
          @click="export_get"
          v-preventReClick
          >导出</jd-button
        >
        <jdTable
          :tableData="lockRightTable"
          :tableInfo="lockRightTableColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalLockRight
          }"
          @handlePage="handlePageLockRight"
          :loading="loading"
        >
        </jdTable>
      </el-tab-pane>

      <!-- 中奖纪录 -->
      <el-tab-pane
        :label="
          fitersRepurchase([16, 17, 18, 23, 24, 27, 28, 45], '领奖记录', '中奖记录')
        "
        name="third"
        v-if="
          fitersChooseIF(
            [13, 14, 15, 21, 25, 9, 10, 29, 30, 31, 32, 33, 35, 36, 37,38,39,56,57],
            '!='
          )
        "
      >     
        <jd-form
          :formInfo="initInputAwardFormInfo()"
          @search="searchAwardOne"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="float: left; margin-bottom: 16px; margin-right: 8px"
          @click="addCrowd(3)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          style="margin-bottom: 16px;"
          @click="batchMark(2)"
          v-preventReClick
          >批量标记发放</jd-button
        >
        <jd-button
          type="text"
          style="float: right;margin-top: 20px;"
          @click="exportFn"
          v-preventReClick
          >导出</jd-button
        >
        <jdTable
          :tableData="awardTable"
          :tableInfo="getAwardTableColumns()"
          :selection="true"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalAward
          }"
          :rowKey="row => row.id"
          @handlePage="handlePageAward"
          :loading="loading"
          @selection-change="handleSelectionChange"
        >
          <!-- 奖品类型插槽 -->
          <template #prizeType="{ row }">
            <span v-if="row.prizeType == 1">优惠券</span>
            <span v-if="row.prizeType == 2">京豆</span>
            <span v-if="row.prizeType == 3">实物</span>
            <span v-if="row.prizeType == 4">店铺积分</span>
            <span v-if="row.prizeType == 5">京豆E卡</span>
            <span v-if="row.prizeType == 6">爱奇艺会员</span>
            <span v-if="row.prizeType == 7">京东PLUS会员</span>
            <span v-if="row.prizeType == 8">现金红包</span>
            <span v-if="row.prizeType == 9">谢谢参与</span>
          </template>
          <!-- 订单号表头插槽 -->
          <template #orderHeader>
            <div>
              订单号
              <el-popover v-if="rowData.activityType == 16" placement="bottom" width="100%" trigger="hover">
                <div class="referencePopover">
                  <span>梯度奖品会显示所有解锁成功且满足领奖条件的订单号</span>
                </div>
                <span class="new-icon-box" slot="reference"></span>
              </el-popover>
            </div>
          </template>
          <!-- 订单号插槽 -->
          <template #orderId="{ row }">
            <!-- 下单有礼页面 -->
            <el-popover v-if="rowData.activityType == 16" placement="bottom" width="100%" trigger="hover">
              <div class="referencePopover" v-for="(item,idx) in row.orderList" :key="idx">
                <span>订单号：{{ item.orderId }}</span>
                <span>订单金额：{{ item.price }}元</span>
                <span>订单状态：{{ item.orderState }}</span>
              </div>
              <span class="referenceButton" slot="reference">{{ row.unlockOrderIdStr }}</span>
            </el-popover>
            <!-- 非下单有礼页面 -->
            <el-popover v-else placement="bottom" width="100%" trigger="hover">
              <div class="referencePopover" v-for="(item,idx) in row.orderList" :key="idx">
                <span>订单号：{{ item.orderId }}</span>
                <span>订单金额：{{ item.price }}元</span>
                <span>订单状态：{{ item.orderState }}</span>
              </div>
              <span class="referenceButton" slot="reference">{{ row.unlockOrderId }}</span>
            </el-popover>
          </template>
          
          <!-- 是否白名单插槽 -->
          <template #isWhite="{ row }">
            <span v-if="row.isWhite == 1">是</span>
            <span v-else>否</span>
          </template>
          
          <!-- 时间插槽 -->
          <template #joinTime="{ row }">
            {{ row.joinTime || "--" }}
          </template>
          
          <!-- 中奖时间插槽 -->
          <template #winTime="{ row }">
            {{ rowData.activityType == 6 ? row.joinTime : row.grantTime || "--" }}
          </template>
          
          <!-- 发放时间插槽 -->
          <template #grantTime="{ row }">
            {{ row.grantTime || "--" }}
          </template>
          
          <!-- 状态插槽 -->
          <template #status="{ row }">
            <span v-if="row.status == -1"><span class="yellow-status-icon"></span>待领取</span>
            <span v-if="row.status == 0">-</span>
            <span v-if="row.status == 1"><span class="red-status-icon"></span>未中奖</span>
            <span v-if="row.status == 2">
              <span :class="fitersChooseIF([16, 17, 18, 27]) ? 'yellow-status-icon' : 'green-status-icon'">
              </span>
              {{ fitersChooseIF([16, 17, 18, 27]) ? "待发放" : "已中奖" }}
            </span>
            <span v-if="row.status == 3"><span class="green-status-icon"></span>已发放</span>
            <span v-if="row.status == 4"><span class="red-status-icon"></span>发放失败</span>
            <span v-if="row.status == 5"><span class="green-status-icon"></span>已发放</span>
            <span v-if="row.status == 6"><span class="green-status-icon"></span>已发放</span>
            <span v-if="row.status == 7"><span class="yellow-status-icon"></span>待发放</span>
            <span v-if="row.status == 8"><span class="grey-status-icon"></span>已失效</span>
            <el-tooltip effect="dark" v-if="row.status == 4" :content="row.failReason" placement="top-start">
              <i style="color: #ccc" v-if="row.status == 4" class="el-icon-question"></i>
            </el-tooltip>
          </template>
          
          <!-- 操作插槽 -->
          <template #action="{ row }">
            <jd-button
              type="blueText"
              v-if="row.status == 4"
              @click="markIss(row)"
            >标记发放</jd-button>
            <jd-button
              type="blueText"
              v-if="row.status == 6"
              @click="markIss(row)"
            >取消发放</jd-button>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 中奖纪录 -->
      <el-tab-pane label="中奖记录" name="third" v-if="fitersChooseIF([33])">
        <jd-form
          :formInfo="inputAwardTwoFormInfo"
          ref="export_fun33"
          @search="searchAwardOne"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="margin-bottom: 16px;"
          @click="addCrowd(3)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          style="margin-bottom: 16px; margin-left: 8px"
          @click="batchMark(1)"
          v-preventReClick
          >批量标记发货</jd-button
        >
        <jd-button
          type="text"
          width="80px"
          style="float: right;margin-top: 20px;"
          @click="export_get"
          v-preventReClick
          >导出</jd-button
        >
        <jdTable
          :tableData="awardTable"
          :tableInfo="awardTableColumns"
          :selection="true"
          :rowKey="row => row.id"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalAward
          }"
          @handlePage="handlePageAward"
          :loading="loading"
          @selection-change="handleSelectionChange"
        >
          <!-- 发货状态插槽 -->
          <template #deliveryStatus="{ row }">
            {{ row.status == 5 ? "已发货" : "未发货" }}
          </template>

          <!-- 收件人插槽 -->
          <template #receiverName="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverName }}
              <div
                class="openHover"
                v-if="
                  row.receiverName &&
                  row.receiverName.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverName',
                    'awardTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div>
            </div>
          </template>

          <!-- 收件人手机号插槽 -->
          <template #receiverMobile="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverMobile }}
              <div
                class="openHover"
                v-if="
                  row.receiverMobile &&
                  row.receiverMobile.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverMobile',
                    'awardTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div>
            </div>
          </template>

          <!-- 收件人地址插槽 -->
          <template #receiverAddress="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverAddress }}
              <div
                class="openHover"
                v-if="
                  row.receiverAddress &&
                  row.receiverAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverAddress',
                    'awardTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div>
            </div>
          </template>

          <!-- 收件人详细地址插槽 -->
          <template #detailedAddress="{ row, rowIndex }">
            <div class="open">
              {{ row.detailedAddress }}
              <div
                class="openHover"
                v-if="
                  row.detailedAddress &&
                  row.detailedAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'detailedAddress',
                    'awardTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div>
            </div>
          </template>

          <!-- 操作插槽 -->
          <template #action="{ row }">
            <!-- 非特定活动类型的操作 -->
            <template v-if="fitersChooseIF([16, 17, 18, 19, 27, 28], '!=')">
              <jd-button
                type="blueText"
                v-if="
                  (row.status == 2 || row.status == 7) &&
                  row.recordId
                "
                @click="markIss(row)"
                style="margin-right: 8px"
                >标记发货</jd-button
              >
              <jd-button
                type="blueText"
                v-if="row.status == 5"
                @click="markIss(row)"
                style="margin-right: 8px"
                >取消发货</jd-button
              >
            </template>

            <!-- 特定活动类型的操作 -->
            <template v-else>
              <jd-button
                type="blueText"
                v-if="row.status == 4 || row.status == 7"
                @click="markIss(row)"
                style="margin-right: 8px"
                >标记发放</jd-button
              >
              <jd-button
                type="blueText"
                style="margin-right: 8px"
                v-if="row.status == 6 || row.status == 5"
                @click="markIss(row)"
                >取消发放</jd-button
              >
            </template>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 中奖纪录 积分锁权 -->
      <el-tab-pane label="中奖记录" name="sixteen" v-if="fitersChooseIF([35,37])">
        <jd-form
          :formInfo="inputAwardFourFormInfo"
          ref="export_fun16"
          @search="searchAwardFour"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="margin-bottom: 16px;"
          @click="batchLock()"
          v-preventReClick
          >批量发货</jd-button
        >
        <jd-button
          type="text"
          style="float: right; margin-top: 20px"
          @click="export_get"
          v-preventReClick
          >导出</jd-button
        >
        <jdTable
          :tableData="awardTable"
          :tableInfo="awardTableFourColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalAward
          }"
          @handlePage="handlePageAward"
          :loading="loading"
        >
          <!-- 姓名插槽 -->
          <template #memberNick="{ row, rowIndex }">
            <div class="open">
              {{ row.memberNick }}
              <div
                class="openHover"
                v-if="
                  row.memberNick &&
                  row.memberNick.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'memberNick',
                    'awardTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div>
            </div>
          </template>
        
          <!-- 手机号码插槽 -->
          <template #mobile="{ row, rowIndex }">
            <div class="open">
              {{ row.mobile }}
              <div
                class="openHover"
                v-if="row.mobile && row.mobile.indexOf('*') != -1"
                @click="
                  handleDecrypt(
                    'mobile',
                    'awardTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div>
            </div>
          </template>
        
          <!-- 地区插槽 -->
          <template #receiverAddress="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverAddress }}
              <div
                class="openHover"
                v-if="
                  row.receiverAddress &&
                  row.receiverAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverAddress',
                    'awardTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div>
            </div>
          </template>
        
          <!-- 详细地址插槽 -->
          <template #detailedAddress="{ row, rowIndex }">
            <div class="open">
              {{ row.detailedAddress }}
              <div
                class="openHover"
                v-if="
                  row.detailedAddress &&
                  row.detailedAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'detailedAddress',
                    'awardTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div>
            </div>
          </template>
        
          <!-- 操作插槽 -->
          <template #actionFour="{ row }">
            <jd-button
              type="blueText"
              v-if="row.sendStatus == 1"
              @click="sendGoods(row)"
              style="text-align: left; margin-right: 8px"
              >发货</jd-button
            >
            <jd-button 
              type="blueText" 
              v-else 
              style="text-align: left; margin-right: 8px" 
              disabled
              >发货</jd-button
            >
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 领奖记录 打榜有礼  -->
      <el-tab-pane label="领奖记录" name="twenty-one" v-if="fitersChooseIF([36])">
        <jd-form
          :formInfo="inputAwardFiftenFormInfo"
          ref="export_fun_lj2"
          @search="searchAwardFifteen"
          style="margin: 20px 0"
        ></jd-form>
        <div style="z-index: 999;position: relative;">
                  <jd-button
          style="float: left; margin-bottom: 16px; margin-right: 8px"
          @click="addCrowd(3)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          type="text"
          style="float: right; margin-top: 20px"
          @click="control3 = true"
          v-preventReClick
          >导出</jd-button
        >
        </div>
        <jdTable
          :tableData="activityTable"
          :tableInfo="chongBangAwardTableColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalAward
          }"
          @handlePage="handlePageFifteen"
          :loading="loading"
        >
          <!-- 总订单金额（已付款）表头插槽 -->
          <template #totalPayMoneyHeader>
            <span>总订单金额（已付款）</span>
            <el-tooltip
              class="item"
              effect="light"
              content="自营店铺为订单金额，POP店铺统计规则以活动实际设置为准"
              placement="top"
            >
              <span class="question_iconOne">?</span>
            </el-tooltip>
          </template>

          <!-- 总订单金额（已收货）表头插槽 -->
          <template #totalFinishMoneyHeader>
            <span>总订单金额（已收货）</span>
            <el-tooltip
              class="item"
              effect="light"
              content="自营店铺为订单金额，POP店铺统计规则以活动实际设置为准"
              placement="top"
            >
              <span class="question_iconOne">?</span>
            </el-tooltip>
          </template>

          <!-- 订单号插槽 -->
          <template #orderIdStr="{ row }">
            <el-tooltip effect="light" :content="row.orderIdStr" placement="top">
              <div class="two-line">{{ row.orderIdStr }}</div>
            </el-tooltip>
          </template>

          <!-- 操作插槽 -->
          <template #chongBangAction="{ row }">
            <jd-button 
              type="blueText" 
              @click="chongBangAwardMark(row)" 
              v-if="row.status == 4"
            >
              标记发放
            </jd-button>
            <jd-button 
              type="blueText" 
              @click="chongBangAwardMark(row)" 
              v-if="row.status == 6"
            >
              取消发放
            </jd-button>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 收货信息 锁权和派样回购-->
      <el-tab-pane
        label="收货信息"
        name="seventeen"
        v-if="fitersChooseIF([35, 37])"
      >
        <jd-form
          :formInfo="inputTakeGoodsFormInfo"
          ref="export_fun17"
          @search="searchTakeGoods"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          style="float: right; margin: 10px 0; position: relative; z-index: 4;"
          @click="export_get"
          v-preventReClick
          type="text"
          >导出</jd-button
        >
        <jdTable
          :tableData="takeGoodsTable"
          :tableInfo="takeGoodsTableColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalTakeGoods
          }"
          @handlePage="handlePageTakeGoods"
          :loading="loading"
        >
          <!-- 姓名插槽 -->
          <template #memberNick="{ row, rowIndex }">
            <div class="open">
              {{ row.memberNick }}
              <div
                class="openHover"
                v-if="
                  row.memberNick &&
                  row.memberNick.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'memberNick',
                    'takeGoodsTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div>
            </div>
          </template>
        
          <!-- 手机号码插槽 -->
          <template #mobile="{ row, rowIndex }">
            <div class="open">
              {{ row.mobile }}
              <div
                class="openHover"
                v-if="row.mobile && row.mobile.indexOf('*') != -1"
                @click="
                  handleDecrypt(
                    'mobile',
                    'takeGoodsTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div>
            </div>
          </template>
        
          <!-- 地区插槽 -->
          <template #receiverAddress="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverAddress }}
              <div
                class="openHover"
                v-if="
                  row.receiverAddress &&
                  row.receiverAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverAddress',
                    'takeGoodsTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div>
            </div>
          </template>
        
          <!-- 详细地址插槽 -->
          <template #detailedAddress="{ row, rowIndex }">
            <div class="open">
              {{ row.detailedAddress }}
              <div
                class="openHover"
                v-if="
                  row.detailedAddress &&
                  row.detailedAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'detailedAddress',
                    'takeGoodsTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div>
            </div>
          </template>
        
          <!-- 操作插槽 -->
          <template #actionTakeGoods="{ row }">
            <jd-button
              type="blueText"
              @click="editAddress(row)"
              style="text-align: left"
              >修改</jd-button
            >
          </template>
        </jdTable>
      </el-tab-pane>
      
      <!-- 实物奖品 -->
      <el-tab-pane label="实物奖品名单" name="four" v-if="fitersChooseIF([13, 14, 15, 21, 25, 9, 10, 29, 30, 31, 32, 33, 35, 36, 37,38,39,56,57],'!=')">
        <jd-form
          :formInfo="fitersChooseIF([16,18,17,19,27,28])? inputInkidNeedAwardFormInfo: inputInkindFormInfo"
          ref="export_fun_sw"
          @search="searchInkind"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="float: left; margin-bottom: 16px;margin-right: 8px"
          @click="addCrowd(4)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          style="margin-bottom: 16px;margin-right: 8px"
          @click="batchMarkForShipment"
          v-preventReClick
          >批量标记发货</jd-button
        >
        <jd-button
          type="text"
          style="float: right; margin-top: 20px"
          @click="export_fun"
          v-preventReClick
          >导出</jd-button
        >
        <jdTable
          :tableData="inkindTable"
          :tableInfo="initInkindTableColumns()"
          :selection="true"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalInkind
          }"
          @handlePage="handlePageInkind"
          :rowKey="row => row.id"
          @selection-change="handleSelectionChange"
          :loading="loading"
        >
          <!-- 商品信息插槽 -->
          <template #goodsInfo="{ row }">
            <div class="goodsInfo">
              <div class="goodsInfo_logo">
                <img :src="row.logo" alt="" />
              </div>
              <div
                class="goodsInfo_text"
                @click="jumpTo"
                v-if="row.skuId"
              >
                <a
                  :href="`http://item.jd.com/${row.skuId}.html`"
                  target="_blank"
                  >{{ row.skuName }}<br />
                  <span style="color: #666666"
                    >skuId:{{ row.skuId }}</span
                  >
                </a>
              </div>
              <div class="goodsInfo_text" v-else>
                <div>{{ row.skuName }}</div>
              </div>
            </div>
          </template>
        
          <!-- 中奖状态/发放状态插槽 -->
          <template #prizeStatus="{ row }">
            <span v-if="row.prizeStatus == -1"><span class="yellow-status-icon"></span>待领取</span>
            <span v-if="row.prizeStatus == 0">-</span>
            <span v-if="row.prizeStatus == 1"><span class="red-status-icon"></span>未中奖</span>
            <span v-if="row.prizeStatus == 2" class="y2">
              <span :class="fitersChooseIF([19]) ? 'blue-status-icon' : 'yellow-status-icon'">
              </span>
              {{ fitersChooseIF([19]) ? "已中奖" : "待发放" }}
            </span>
            <span v-if="row.prizeStatus == 3"><span class="green-status-icon"></span>已发放</span>
            <span v-if="row.prizeStatus == 4"><span class="red-status-icon"></span>发放失败</span>
            <span v-if="row.prizeStatus == 5"><span class="green-status-icon"></span>已发放</span>
            <span v-if="row.prizeStatus == 6"><span class="green-status-icon"></span>已发放</span>
            <span v-if="row.prizeStatus == 7"><span class="yellow-status-icon"></span>待发放</span>
            <span v-if="row.prizeStatus == 8"><span class="grey-status-icon"></span>已失效</span>
          </template>
        
          <!-- 发货状态插槽 -->
          <template #grantStatus="{ row }">
            {{ row.status == 5 ? "已发货" : "未发货" }}
          </template>
        
          <!-- 收件人插槽 -->
          <template #receiverName="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverName ? row.receiverName : '-' }}
              <!-- <div
                class="openHover"
                v-if="
                  row.receiverName &&
                  row.receiverName.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverName',
                    'inkindTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div> -->
            </div>
          </template>
        
          <!-- 收件人手机号插槽 -->
          <template #receiverMobile="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverMobile ? row.receiverMobile : '-' }}
              <!-- <div
                class="openHover"
                v-if="
                  row.receiverMobile &&
                  row.receiverMobile.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverMobile',
                    'inkindTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div> -->
            </div>
          </template>
        
          <!-- 收件人地区插槽 -->
          <template #receiverAddress="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverAddress ? row.receiverAddress : '-'}}
              <!-- <div
                class="openHover"
                v-if="
                  row.receiverAddress &&
                  row.receiverAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverAddress',
                    'inkindTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div> -->
            </div>
          </template>
        
          <!-- 收件人详细地址插槽 -->
          <template #detailedAddress="{ row, rowIndex }">
            <div class="open">
              {{ row.detailedAddress ? row.detailedAddress : '-' }}
              <!-- <div
                class="openHover"
                v-if="
                  row.detailedAddress &&
                  row.detailedAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'detailedAddress',
                    'inkindTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div> -->
            </div>
          </template>
        
          <!-- 操作插槽 -->
          <template #action="{ row }">
            <jd-button
              type="blueText"
              v-if="row.status == 5"
              @click="markIss(row)"
              >取消发货</jd-button
            >
            <jd-button
              type="blueText"
              v-if="(row.status == '2' || row.status == '7') && row.id"
              @click="markIss(row)"
              >标记发货</jd-button
            >
            <jd-button
              type="blueText"
              v-if="(row.status == '2' || row.status == '7') && !row.id"
              >
              标记发货
              </jd-button>
            <!-- 京获客v2.5迭代：快递单号登记 -->
            <jd-button type="blueText" style="margin-left: 8px"   @click="handleEnterCoutierNum(row)" v-if=" row.id"
              >录入快递单号</jd-button
            >
            <jd-button type="blueText" style="margin-left: 8px"   v-else
                >录入快递单号</jd-button
              >
          </template>
        </jdTable>
      </el-tab-pane>
      
      <!-- 领取记录 -->
      <el-tab-pane
        label="领取记录"
        name="getRecord"
        v-if="fitersChooseIF([39])"
      >
        <jd-form
          :formInfo="recordFormInfo"
          @search="searchFormRecord"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="margin-bottom: 16px; margin-right: 8px"
          @click="addCrowd(3)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
            @click="exportTheData"
            type="text"
            v-preventReClick
            style="float: right; margin-top: 20px"
            >导出</jd-button
          >
        <!-- 表格 -->
        <jdTable
          :tableData="getRecordList"
          :tableInfo="recordTableColumns"
          :pageInfo="{
            pageNum: formListRecord.current,
            pageSize: formListRecord.size,
            total: totalRecord
          }"
          @handlePage="handlePageRecord"
          :loading="loading"
        >
          <!-- 登记生日插槽 -->
          <template #birthDay="{ row }">
            <span>{{ row.birthDay ? row.birthDay.split(" ")[0] : '-' }}</span>
          </template>
        
          <!-- 奖品类型插槽 -->
          <template #prizeType="{ row }">
            <span v-if="row.prizeType == 1">优惠券</span>
            <span v-else-if="row.prizeType == 2">京豆</span>
            <span v-else-if="row.prizeType == 3">实物</span>
            <span v-else-if="row.prizeType == 4">店铺积分</span>
            <span v-else-if="row.prizeType == 5">E卡</span>
            <span v-else-if="row.prizeType == 6">爱奇艺会员</span>
            <span v-else-if="row.prizeType == 7">京豆PlUS会员</span>
            <span v-else-if="row.prizeType == 8">红包</span>
            <span v-else-if="row.prizeType == 9">谢谢参与</span>
            <span v-else>-</span>
          </template>
        
          <!-- 奖品名称插槽 -->
          <template #prizeName="{ row }">
            <span v-if="row.prizeName">{{ row.prizeName }}</span>
            <span v-else>-</span>
          </template>
        
          <!-- 中奖状态插槽 -->
          <template #status="{ row }">
            <span v-if="row.status == 2">已中奖</span>
            <span v-if="row.status == 3 || row.status == 5 || row.status == 6">已发放</span>
            <span v-if="row.status == 4">发放失败</span>
          </template>
        
          <!-- 操作插槽 -->
          <template #actionRecord="{ row }">
            <jd-button type="blueText" @click="recordMark(row)" v-if="row.status == 4">
              标记发放
            </jd-button>
          </template>
        </jdTable>
      </el-tab-pane>
      
      <!-- 打榜有礼实物奖品名单-->
      <el-tab-pane label="实物奖品名单" name="twenty" v-if="fitersChooseIF([36,39])" >
        <jd-form
          :formInfo="rowData.activityType == 39 ? inputInkind3FormInfo : inputInkind2FormInfo"
          @search="searchGoodRecordsPage"
          ref="export_fun_sw2"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          v-if="rowData.activityType != 39"
          style="float: left; margin-bottom: 16px;margin-right: 8px"
          type="break"
          @click="addCrowd(4)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          style="margin-bottom: 16px;margin-right: 8px"
          @click="physicalBatchShipment"
          v-preventReClick
          >批量发货</jd-button
        >
        <jd-button
          type="text"
          style="float: right; margin-top: 20px"
          @click="goodsExportDialog"
          v-preventReClick
          >导出</jd-button
        >
        <jdTable
          :tableData="goodsRecordTable"
          :tableInfo="initGoodsRecordTableColumns()"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalAward
          }"
          @handlePage="handlePageGoods"
          :loading="loading"
        >
          <!-- 姓名插槽 -->
          <template #receiverName="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverName ? row.receiverName : '-' }}
              <!-- <div
                class="openHover"
                v-if="
                  row.receiverName &&
                  row.receiverName.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverName',
                    'goodsRecordTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div> -->
            </div>
          </template>

          <!-- 手机号码插槽（活动类型39） -->
          <template #receiverMobile="{ row, rowIndex }" v-if="rowData.activityType == 39">
            <div class="open">
              {{ row.receiverMobile ? row.receiverMobile : '-' }}
              <!-- <div
                class="openHover"
                v-if="
                  row.receiverMobile &&
                  row.receiverMobile.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverMobile',
                    'goodsRecordTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div> -->
            </div>
          </template>

          <!-- 手机号码插槽（其他活动类型） -->
          <template #mobile="{ row, rowIndex }">
            <div class="open">
              {{ row.mobile ? row.mobile : '-' }}
              <!-- <div
                class="openHover"
                v-if="
                  row.mobile &&
                  row.mobile.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'mobile',
                    'goodsRecordTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div> -->
            </div>
          </template>

          <!-- 地区插槽 -->
          <template #receiverAddress="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverAddress ? row.receiverAddress : '-' }}
              <!-- <div
                class="openHover"
                v-if="
                  row.receiverAddress &&
                  row.receiverAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverAddress',
                    'goodsRecordTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div> -->
            </div>
          </template>

          <!-- 详细地址插槽 -->
          <template #detailedAddress="{ row, rowIndex }">
            <div class="open">
              {{ row.detailedAddress ? row.detailedAddress : '-' }}
              <!-- <div
                class="openHover"
                v-if="
                  row.detailedAddress &&
                  row.detailedAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'detailedAddress',
                    'goodsRecordTable',
                    row,
                    rowIndex
                  )
                "
              >
                展开
              </div> -->
            </div>
          </template>

          <!-- 奖品状态插槽 -->
          <template #prizeStatus="{ row }">
            <span>{{ row.prizeStatusStr }}</span>
          </template>

          <!-- 操作插槽 -->
          <template #actionGoods="{ row }">
            <jd-button
              type="blueText"
              @click="chongBangPhysicalMark(row)"
              size="small"
            >
              发货
            </jd-button>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 资料明细 -->
      <el-tab-pane label="用户资料明细" name="five" v-if="fitersChooseIF([7])">
         <jd-form
          :formInfo="inputUserInfoFormInfo"
          @search="searchUserInfo"
          :btn30="true"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="text"
          style="float: right; margin: 10px 0"
          @click="getphone()"
          v-preventReClick
          >导出</jd-button
        >
          <jdTable
            :tableData="userInfoTable"
            :tableInfo="userInfoTableColumns"
            :pageInfo="{
              pageNum: formList.current,
              pageSize: formList.size,
              total: totalUserInfo
            }"
            @handlePage="handlePageUserInfo"
            :loading="loading"
          >
            <!-- 姓名插槽 -->
            <template #name="{ row, rowIndex }">
              <div class="open">
                {{ row.name }}
                <div
                  class="openHover"
                  v-if="row.name && row.name.indexOf('*') != -1"
                  @click="handleDecrypt('name', 'userInfoTable', row, rowIndex)"
                >
                  展开
                </div>
              </div>
            </template>
          
            <!-- 手机号插槽 -->
            <template #mobile="{ row, rowIndex }">
              <div class="open">
                {{ row.mobile }}
                <div
                  class="openHover"
                  v-if="row.mobile && row.mobile.indexOf('*') != -1"
                  @click="handleDecrypt('mobile', 'userInfoTable', row, rowIndex)"
                >
                  展开
                </div>
              </div>
            </template>
          
            <!-- 生日插槽 -->
            <template #birthDay="{ row, rowIndex }">
              <div class="open">
                {{ row.birthDay }}
                <div
                  class="openHover"
                  v-if="row.birthDay && row.birthDay.indexOf('*') != -1"
                  @click="handleDecrypt('birthDay', 'userInfoTable', row, rowIndex)"
                >
                  展开
                </div>
              </div>
            </template>
          
            <!-- QQ插槽 -->
            <template #qq="{ row, rowIndex }">
              <div class="open">
                {{ row.qq }}
                <div
                  class="openHover"
                  v-if="row.qq && row.qq.indexOf('*') != -1"
                  @click="handleDecrypt('qq', 'userInfoTable', row, rowIndex)"
                >
                  展开
                </div>
              </div>
            </template>
          
            <!-- 微信插槽 -->
            <template #weChat="{ row, rowIndex }">
              <div class="open">
                {{ row.weChat }}
                <div
                  class="openHover"
                  v-if="row.weChat && row.weChat.indexOf('*') != -1"
                  @click="handleDecrypt('weChat', 'userInfoTable', row, rowIndex)"
                >
                  展开
                </div>
              </div>
            </template>
          
            <!-- 性别插槽 -->
            <template #sex="{ row, rowIndex }">
              <div class="open">
                <span v-if="row.sex.indexOf('*') != -1">{{ row.sex }}</span>
                <span v-if="row.sex == 0">未知</span>
                <span v-if="row.sex == 1">男</span>
                <span v-if="row.sex == 2">女</span>
                <div
                  class="openHover"
                  v-if="row.sex && row.sex.indexOf('*') != -1"
                  @click="handleDecrypt('sex', 'userInfoTable', row, rowIndex)"
                >
                  展开
                </div>
              </div>
            </template>
          
            <!-- 职业插槽 -->
            <template #job="{ row, rowIndex }">
              <div class="open">
                {{ row.job }}
                <div
                  class="openHover"
                  v-if="row.job && row.job.indexOf('*') != -1"
                  @click="handleDecrypt('job', 'userInfoTable', row, rowIndex)"
                >
                  展开
                </div>
              </div>
            </template>
          
            <!-- 地区插槽 -->
            <template #address="{ row, rowIndex }">
              <div class="open">
                {{ row.address }}
                <div
                  class="openHover"
                  v-if="row.address && row.address.indexOf('*') != -1"
                  @click="handleDecrypt('address', 'userInfoTable', row, rowIndex)"
                >
                  展开
                </div>
              </div>
            </template>
          
            <!-- 详细地址插槽 -->
            <template #detailedAddress="{ row, rowIndex }">
              <div class="open">
                {{ row.detailedAddress }}
                <div
                  class="openHover"
                  v-if="row.detailedAddress && row.detailedAddress.indexOf('*') != -1"
                  @click="handleDecrypt('detailedAddress', 'userInfoTable', row, rowIndex)"
                >
                  展开
                </div>
              </div>
            </template>
          
            <!-- 扩展信息插槽 -->
            <template #extendInfo="{ row }">
              <div style="display: flex;flex-wrap: wrap;">
                <div v-for="(item,index) in showextendInfo(row.extendInfo)" class="info" :key="index">
                  <div style="min-width: 60px;margin-right: 8px;">{{item.prop}}:</div>
                  <template v-if="item.isImg">
                   <div class="img-parent" v-for="child in item.keys" :key="child">
                    <img class="info-img" :src="child" :preview-src-list="[child]" />
                    <div class="mask" @click="handlePictureCardPreview(child)">
                      <i class="el-icon-zoom-in"></i>
                    </div>
                   </div>
                  </template>
                  <span v-else style="margin-left: 4px">{{item.keys}}</span>
                  <span v-if="index!=showextendInfo(row.extendInfo).length-1">；</span>
                </div>
              </div>
            </template>
          </jdTable>
      </el-tab-pane>

      <!-- 发放记录 -->
      <el-tab-pane label="发放记录" name="six" v-if="fitersChooseIF([13, 14, 15])">
        <jd-form
          :formInfo="inputAwardOneFormInfo"
          @search="searchAward"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="margin-bottom: 16px;"
          @click="addCrowd(12)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          type="text"
          width="80px"
          style="float: right; margin-top: 20px"
          @click="control1 = true"
          v-preventReClick
          >导出</jd-button
        >
        <jdTable
          :tableData="distributionTable"
          :tableInfo="initDistributionTableColumns()"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalDistribution
          }"
          @handlePage="handlePageAwardOne"
          :loading="loading"
        >
          <!-- 场景插槽 -->
          <template #sceneType="{ row }">
            <span v-if="row.sceneType == 1">未关注店铺用户</span>
            <span v-if="row.sceneType == 2">店铺新客</span>
            <span v-if="row.sceneType == 3">plus会员</span>
            <span v-if="row.sceneType == 4">关注店铺用户</span>
            <span v-if="row.sceneType == 5">店铺会员</span>
          </template>
        
          <!-- 奖品类型插槽 -->
          <template #prizeType="{ row }">
            <span v-if="row.prizeType == 1">优惠券</span>
            <span v-if="row.prizeType == 2">京豆</span>
            <span v-if="row.prizeType == 4">店铺积分</span>
          </template>
        
          <!-- 发放状态插槽 -->
          <template #status="{ row }">
            <span v-if="row.status == 0"><span class="grey-status-icon"></span>未知</span>
            <span v-if="row.status == 3"><span class="green-status-icon"></span>已发放</span>
            <span v-if="row.status == 4"><span class="red-status-icon"></span>发放失败</span>
            <el-tooltip effect="dark" v-if="row.status == 4" :content="row.failReason" placement="top-start">
              <i
                style="color: #ccc"
                v-if="row.status == 4"
                class="el-icon-question"
              ></i>
            </el-tooltip>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 抽奖机会赠送记录 -->
      <el-tab-pane
        label="抽奖机会赠送记录"
        name="seven"
        v-if="fitersChooseIF([20])"
      >
        <jd-form
          :formInfo="inputCommentFormInfo"
          @search="searchComment"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="float: left; margin-bottom: 20px;"
          class="penetrate"
          @click="addCrowd(5)"
          >按查询结果生成人群</jd-button
        >
        <jdTable
          :tableData="CommentList"
          :tableInfo="commentTableColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalComment
          }"
          @handlePage="handlePageComment"
          :loading="loading"
        >
          <!-- 过滤状态插槽 -->
          <template #filterType="{ row }">
            <span v-if="row.filterType == 0"><span class="red-status-icon"></span>未通过</span>
            <span v-if="row.filterType == 1"><span class="green-status-icon"></span>通过</span>
          </template>
        
          <!-- 操作插槽 -->
          <template #actionComment="{ row }">
            <jd-button type="blueText" @click="commentDetails(row)">
              查看详情
            </jd-button>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 拼券明细 -->
      <el-tab-pane
        label="拼券明细"
        name="eight"
        v-if="fitersChooseIF([21, 31])"
      >
        <jd-form
          :formInfo="InputCouponFormInfo"
          @search="searchCoupon"
          style="margin: 20px 0"
          :btn30="true"
        ></jd-form>
        <jd-button
          type="break"
          style="margin-bottom: 16px;"
          @click="addCrowd(9)"
          >按查询结果生成人群</jd-button
        >
        <jdTable
          :tableData="couponDetailsList"
          :tableInfo="initCouponTableColumns()"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalCoupon
          }"
          @handlePage="handlePageCoupon"
          :loading="loading"
        >
          <!-- 角色插槽 -->
          <template #memberRole="{ row }">
            {{ row.memberRole == 1 ? "分享者" : "被分享者" }}
          </template>
        
          <!-- 用户身份插槽 -->
          <template #memberType="{ row }">
            {{ row | typeChinese }}
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 优惠券统计 -->
      <el-tab-pane
        :label="fitersRepurchase([21], '优惠券统计', '优惠券发放统计')"
        name="nine"
        v-if="fitersChooseIF([21, 31])"
      >
        <jd-form
          :formInfo="InputSplitCouponFormInfo"
          @search="searchSplit"
          style="margin: 20px 0"
          :btn30="true"
        ></jd-form>
        <jdTable
          :tableData="CouponStatisticsList"
          :tableInfo="couponStatisticsTableColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalCouponstatistics
          }"
          @handlePage="handlePageCouponStatistics"
          :loading="loading"
          v-if="fitersChooseIF([21])"
        >
        </jdTable>
        
        <jdTable
          :tableData="CouponStatisticsList"
          :tableInfo="couponStatisticsTableColumns"
          :loading="loading"
          v-if="fitersChooseIF([31])"
        >
        </jdTable>
      </el-tab-pane>

      <!-- 团队详情 -->
      <el-tab-pane
        :label="fitersRepurchase([21], '团队详情', '助力详情')"
        name="ten"
        v-if="fitersChooseIF([21, 31])"
      >
        <jd-form
          :formInfo="InputGroupCouponFormInfo"
          @search="searchGroup"
          style="margin: 20px 0"
          :btn30="true"
        ></jd-form>
        <jdTable
          :tableData="TeamDetailsList"
          :tableInfo="initTeamDetailsTableColumns()"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalTeam
          }"
          @handlePage="handlePageTeam"
          :loading="loading"
      >
          <!-- 活动类型21的状态插槽 -->
          <template #teamStatus21="{ row }">
            <span v-if="row.status === 0">未知</span>
            <span v-if="row.status === 1">组团中</span>
            <span v-if="row.status === 2">组团成功</span>
          </template>

          <!-- 活动类型31的状态插槽 -->
          <template #teamStatus31="{ row }">
            <span v-if="row.status === 0"><span class="grey-status-icon"></span>未知</span>
            <span v-if="row.status === 1"><span class="blue-status-icon"></span>拼券中</span>
            <span v-if="row.status === 2"><span class="green-status-icon"></span>拼券成功</span>
            <span v-if="row.status === 3"><span class="red-status-icon"></span>拼券失败</span>
          </template>

          <!-- 操作按钮插槽 -->
          <template #teamAction="{ row }">
            <jd-button type="blueText" @click="viewDetails(row)">{{
              fitersRepurchase([21], "查看详情", "查看明细")
            }}</jd-button>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 参与赠送记录 -->
      <el-tab-pane
        :label="rowData.activityType == 8?'抽奖机会赠送记录':'参与赠送记录'"
        name="twelve"
        v-if="fitersChooseIF([8,23,24])"
      >
        <jd-form
          :formInfo="rowData.activityType == 8 ? InputGiftrecord2FormInfo : InputGiftrecordFormInfo"
          @search="searchGiftrecord"
          style="margin: 20px 0"
          :btn30="true"
        ></jd-form>
        <jd-button
          v-if="fitersChooseIF([23,24])"
          type="break"
          style="margin-bottom: 16px;"
          @click="addCrowd(7)"
          >按查询结果生成人群</jd-button
        >
        <jdTable
          :tableData="GiftrecordList"
          :tableInfo="initGiftrecordTableColumns()"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalGiftrecord
          }"
          @handlePage="handlePageGiftrecord"
          :loading="loading"
        >
          <!-- 获赠类型插槽 -->
          <template #taskType="{ row }">
            <span>{{ rowData.activityType == 8 ? fitersTypeValue2(row.taskType) : fitersTypeValue(row.taskType) }}</span>
          </template>
        
          <!-- 赠送次数插槽（仅活动类型8显示） -->
          <template #giveTimes="{ row }">
            <div style="display: flex; align-items: center">
              <span>{{ row.giveTimes }}</span>
              <el-tooltip placement="top" v-if="row.taskType == 17" popper-class="new-tooltip-width">
                <div slot="content">
                  <div v-for="(fitem, findex) in fitersTypeValue4(row)" :key="'fitersTypeValue4'+ findex">
                    {{ fitem }}
                  </div>
                </div>
                <div style="display: inline-block;margin-left: 5px;width: 140px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">(订单号：{{ fitersTypeValue3(row) }})</div>
              </el-tooltip>
            </div>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 兑换记录 -->
      <el-tab-pane
        label="兑换记录"
        name="thirteen"
        v-if="fitersChooseIF([10, 29, 30,38])"
      >
        <!-- 头部表单查询 -->
         <jd-form
          :formInfo="fitersChooseIF([38]) ? InputDataThirREDFormInfo : InputDataThirFormInfo"
          @search="searchFormThir"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="margin-bottom: 16px;margin-right:8px"
          @click="addCrowd(11)"
          >按查询结果生成人群</jd-button
        >
        <jd-button @click="getphone()" type="text" style="float: right;" v-if="fitersChooseIF([38])">导出</jd-button>
        <jdTable
          :tableData="exchangeList"
          :tableInfo="initExchangeTableColumns()"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalMail
          }"
          @handlePage="handlePageExchange"
          :loading="loading"
        >
          <!-- 礼品类型插槽 -->
          <template #prizeType="{ row }">
            <span v-if="row.prizeType == 1">优惠券</span>
            <span v-if="row.prizeType == 2">京豆</span>
            <span v-if="row.prizeType == 3">实物</span>
            <span v-if="row.prizeType == 5">E卡</span>
          </template>
        
          <!-- 兑换状态插槽 -->
          <template #exchangeStatus="{ row }">
            <span v-if="row.exchangeStatus == 1"><span class="green-status-icon"></span>兑换成功</span>
            <span v-if="row.exchangeStatus == 2">
              <span class="red-status-icon"></span>
              兑换失败
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ask.png"
                alt=""
                class="questionMark"
              />
            </span>
            <span v-if="row.exchangeStatus == 3"><span class="green-status-icon"></span>领取成功</span>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 兑换实物 -->
      <el-tab-pane
        label="兑换记录（实物）"
        name="fourteen"
        v-if="fitersChooseIF([9])"
      >
        <jd-form
          :formInfo="InputDataThir9FormInfo"
          @search="searchFormThir"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="margin-bottom: 16px; margin-right: 8px"
          @click="addCrowd(11)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          style="margin-bottom: 16px; margin-right: 8px"
          @click="batchMark2"
          v-preventReClick
          >批量标记发货</jd-button
        >
        <jd-button
          type="text"
          @click="getphone()"
          style="float: right; margin-top: 20px"
          >导出</jd-button
        >
        <jdTable
          :tableData="exchangeList"
          :tableInfo="exchangeDetailTableColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalMail
          }"
          @handlePage="handlePageExchangeDetail"
          :loading="loading"
          :showSelection="true"
          @selection-change="handleSelectionChange"
        >
          <!-- 礼品类型插槽 -->
          <template #prizeType="{ row }">
            <span v-if="row.prizeType == 1">优惠券</span>
            <span v-if="row.prizeType == 2">京豆</span>
            <span v-if="row.prizeType == 3">实物</span>
            <span v-if="row.prizeType == 5">E卡</span>
          </template>
        
          <!-- 兑换状态插槽 -->
          <template #exchangeStatus="{ row }">
            <span v-if="row.exchangeStatus == 1"><span class="green-status-icon"></span>兑换成功</span>
            <span v-if="row.exchangeStatus == 2">
              <span class="red-status-icon"></span>
              兑换失败
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ask.png"
                alt=""
                class="questionMark"
              />
            </span>
            <span v-if="row.exchangeStatus == 3"><span class="green-status-icon"></span>领取成功</span>
          </template>
        
          <!-- 发货状态插槽 -->
          <template #deliveryStatus="{ row }">
            <span v-if="row.deliveryStatus == 1"><span class="yellow-status-icon"></span>待发货</span>
            <span v-if="row.deliveryStatus == 2"><span class="green-status-icon"></span>已发货</span>
            <span v-if="row.deliveryStatus == 3"><span class="grey-status-icon"></span>无需发货（非实物）</span>
          </template>
        
          <!-- 收货人插槽 -->
          <template #receiverName="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverName ? row.receiverName : '-' }}
              <!-- <div
                class="openHover"
                v-if="
                  row.receiverName &&
                  row.receiverName.indexOf('*') != -1
                "
                @click="
                  handleDecrypt1('receiverName', row, rowIndex)
                "
              >
                展开
              </div> -->
            </div>
          </template>
        
          <!-- 收货地区插槽 -->
          <template #receiverRegion="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverRegion ? row.receiverRegion : '-' }}
              <!-- <div
                class="openHover"
                v-if="
                  row.receiverRegion &&
                  row.receiverRegion.indexOf('*') != -1
                "
                @click="
                  handleDecrypt1('receiverRegion', row, rowIndex)
                "
              >
                展开
              </div> -->
            </div>
          </template>
        
          <!-- 详细地址插槽 -->
          <template #receiverAddress="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverAddress ? row.receiverAddress : '-' }}
              <!-- <div
                class="openHover"
                v-if="
                  row.receiverAddress &&
                  row.receiverAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt1('receiverAddress', row, rowIndex)
                "
              >
                展开
              </div> -->
            </div>
          </template>
        
          <!-- 收件人手机号插槽 -->
          <template #receiverMobile="{ row, rowIndex }">
            <div class="open">
              {{ row.receiverMobile ? row.receiverMobile : '-' }}
              <!-- <div
                class="openHover"
                v-if="
                  row.receiverMobile &&
                  row.receiverMobile.indexOf('*') != -1
                "
                @click="
                  handleDecrypt1('receiverMobile', row, rowIndex)
                "
              >
                展开
              </div> -->
            </div>
          </template>
        
          <!-- 操作插槽 -->
          <template #exchangeAction="{ row }">
            <jd-button
              v-if="row.deliveryStatus == 1 && row.id"
              type="blueText"
              @click="changeShip(row)"
            >
              标记发货
            </jd-button>
            <jd-button
              type="blueText"
              v-if="row.deliveryStatus == 1 && !row.id"
              :disabled="true"
            >
              标记发货
            </jd-button>
          
            <jd-button type="blueText" v-if="row.deliveryStatus == 2" @click="cancelShip(row)"> 取消发货 </jd-button>
            <jd-button type="blueText" style="margin-left: 8px" @click="handleEnterCoutierNum(row)" v-if="row.id"
              >录入快递单号</jd-button
            >
            <jd-button type="blueText" style="margin-left: 8px" v-else
            :disabled="true"
              >录入快递单号</jd-button
            >
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 开卡记录 -->
      <!-- <el-tab-pane label="开卡记录" name="fifteen" v-if="fitersChooseIF([32])">
        <jd-form
          :formInfo="InputDataThir2FormInfo"
          @search="searchFormThir2"
          style="margin: 20px 0"
        ></jd-form>
        <div style="color: #fe4d45; margin-bottom: 10px">
          注意：仅记录点击【开卡】按钮后1个小时内开卡的用户
        </div>
        <jd-button
          type="break"
          style="margin-bottom: 16px;"
          @click="addCrowd(14)"
          >按查询结果生成人群</jd-button
        >
        <jdTable
          :tableData="exchangeList"
          :tableInfo="openCardTableColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalMail
          }"
          @handlePage="handlePageOpenCard"
          :loading="loading"
        >
        </jdTable>
      </el-tab-pane> -->

      <!-- Note---邀请开发有礼C端逻辑优化 -->
      <el-tab-pane label="邀请统计" name="sevent" v-if="fitersChooseIF([5, 6])">
        <jd-form
          :formInfo="InputAwardThreeFormInfo"
          @search="searchAwardStatistics"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          type="break"
          style="margin-bottom: 16px;"
          @click="addCrowd(8)"
          >按查询结果生成人群</jd-button
        >
        <jdTable
          :tableData="invitationNum"
          :tableInfo="initInvitationTableColumns()"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalAwardFor
          }"
          @handlePage="handlePageInvitation"
          :loading="loading"
        >
          <!-- 任务插槽 -->
          <template #taskIndex="{ row }" v-if="isTaskPrize">
            <span>任务{{ $toChinesNum(row.taskIndex) }}</span>
          </template>
        
          <!-- 操作插槽 -->
          <template #invitationAction="{ row }">
            <jd-button
              type="blueText"
              @click="invitationDeatils(row)"
              style="text-align: left;"
            >
              邀请明细
            </jd-button>
          </template>
        </jdTable>
      </el-tab-pane>

      <!-- 被邀请人明细 -->
      <el-tab-pane label="被邀请人明细" name="inviteeDetails" v-if="fitersChooseIF([5])">
        <jd-form
          :formInfo="InviteeDetailsFormInfo"
          @search="inviteeDetailsSearch"
          style="margin: 20px 0"
        ></jd-form>
        <jd-button
          style="float: left; margin-bottom: 20px; width: 150px"
          @click="addCrowd(21)"
          >按查询结果生成人群</jd-button
        >
        <jdTable
          :tableData="inviteeDetailsData"
          :tableInfo="inviteeDetailsTableColumns"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: inviteeDetailsTotal
          }"
          @handlePage="handlePageInviteeDetails"
          :loading="loading"
        >
          <!-- 是否有效邀请插槽 -->
          <template #isValidInvite="{ row }">
            <span>{{ Number(row.isValidInvite) == 1 ? '是' : '否'}}</span>
            <el-tooltip effect="dark" v-if="row.isValidInvite != 1" :content="nowActType == 1 ? '不满足成功入会且有付款条件': nowActType == 2 ? '不满足成功入会且有下单条件': '不满足成功入会'" placement="top-start">
              <i
                style="color: #ccc;margin-left: 4px; cursor: pointer"
                v-if="row.isValidInvite != 1"
                class="el-icon-question"
              ></i>
            </el-tooltip>
          </template>
        
          <!-- 订单号插槽 -->
          <template #orderIds="{ row }">
            {{ row.orderIds ? row.orderIds : '-' }}
          </template>
        
          <!-- 订单数插槽 -->
          <template #orderCount="{ row }">
            {{ row.orderCount ? row.orderCount : 0 }}
          </template>
        
          <!-- 商品件数插槽 -->
          <template #itemCount="{ row }">
            {{ row.itemCount ? row.itemCount : 0 }}
          </template>
        
          <!-- 付款金额插槽 -->
          <template #paymentAmount="{ row }">
            {{ row.paymentAmount ? row.paymentAmount : 0 }}
          </template>
        
          <!-- 邀请时间插槽 -->
          <template #joinTime="{ row }">
            {{ row.joinTime ? row.joinTime : '-' }}
          </template>
        </jdTable>
      </el-tab-pane>
    </el-tabs>
    
    <!-- 团队弹框 -->
    <jd-dialog
      :title="fitersRepurchase([21], '组团明细', '拼券明细')"
      :visible.sync="dialogGroup"
      width="1200px"
      @close="dialogGroup = false"
      :isShowSure="false"
      :isShowCancel="false"
    >
      <jd-table
      :tableData="CouponMember"
      :tableInfo="initGroupMemberTableColumns()"
    >
      <template #memberInfo="{ row }">
        <div style="display: flex; align-items: center">
          <div class="imgurl"><img :src="row.avatar" alt="" /></div>
          <span>{{ row.name }}</span>
        </div>
      </template>
    </jd-table>
    </jd-dialog>

    <!-- Note--邀请明细弹框 -->
    <jd-dialog
      title="助力明细"
      :visible.sync="dialogDeatils"
      width="1200px"
      @close="dialogDeatils = false"
      :isShowSure="false"
      :isShowCancel="false"
    >
      <div class="new-table-box">
        <jd-table
          :loading="loading1"
          :tableData="CouponMember1"
          :tableInfo="initCouponMemberTableColumns()"
          :pageInfo="{
            current: formList1.current,
            size: formList1.size,
            total: totalNum
          }"
          @handlePage="handlePageCouponMember"
        >
          <template #isOpenCard="{ row }">
            <span>{{ row.isOpenCard == 1 ? "已入会" : "未入会" }}</span>
          </template>
        </jd-table>
      </div>
    </jd-dialog>

    <!-- 导出弹框 -打榜有礼导出弹框 -->
    <jd-dialog
      v-if="dialogExprot"
      :title="fitersChooseIF([36, 37]) ? '导出' : '身份验证'"
      :visible.sync="dialogExprot"
      :width="fitersChooseIF([36, 37]) ? '500px' : '600px'"
      class="system-dialog"
      @close="dialogExprot = false"
      :isShowSure="false"
      :isShowCancel="false"
    >
      <div class="form-box new-input-box">
        <div class="form-item">
          <div :class="fitersChooseIF([36, 37]) ? 'item-label2' : 'item-label'">
            {{ fitersChooseIF([36, 37]) ? "手机号码：" : "手机号：" }}
          </div>
          <div class="item-value">
            <el-input
              disabled
              placeholder="请输入..."
              v-model="loginUserInfo.mobile"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div :class="fitersChooseIF([36, 37]) ? 'item-label2' : 'item-label'">
            {{ fitersChooseIF([36, 37]) ? "手机验证码：" : "验证码：" }}
          </div>
          <div class="item-value">
            <el-input
              placeholder="请输入"
              v-model="code"
              style="width: 170px; margin-right: 12px"
            ></el-input>
            <jd-button
              type="blue"
              :disabled="codeDisabled"
              @click="getCode"
              >{{ codeMsg }}</jd-button
            >
          </div>
        </div>
        <div class="form-item" style="margin-bottom: 8px">
          <div class="form-item" style="margin-bottom: 8px">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="tip-box" style="background: #fff"></div>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="save-btn">
          <template v-if="fitersChooseIF([36])">
            <jd-button type="default" @click="dialogExprot = false">取消</jd-button>
            <jd-button type="blue" style="margin-left: 8px" @click="getApi_Exprot2(
              tabName == 'twenty-one' ? 2 : 
              tabName == 'twenty' ? 3 : 
              1)"
            >确认</jd-button>
          </template>
          <template v-else-if="fitersChooseIF([37]) && tabName != 'seventeen' && tabName != 'sixteen'">
            <jd-button type="default" @click="dialogExprot = false">取消</jd-button>
            <!-- 1是数据统计、2是派样下单、3是回购下单记录 -->
            <jd-button type="blue"  style="margin-left: 8px"  @click="getApi_Exprot3(
              tabName == 'sendReBuyPay' ? 2 : 
              tabName == 'sendReBuyRePay' ? 3 : 
              1)"
            >确认</jd-button>
          </template>
          <template v-else>
            <jd-button type="blue" @click="getApi_Exprot()">确定</jd-button>
            <jd-button type="default"  style="margin-left: 8px" @click="dialogExprot = false">取消</jd-button>
          </template>
        </div>
      </template>
    </jd-dialog>

    <evaluation-dialog
      v-model="commentDioag"
      :commentItem="commentItem"
      @dialogClose="dialogClose"
    />

    <jd-dialog
      title="身份验证"
      width="420px"
      :show-close="false"
      :visible.sync="visible"
      class="system-dialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @confirm="savePhone()"
      @close="visible = false"
    >
      <div class="form-box new-input-box">
        <div class="form-item">
          <div class="item-label">手机号：</div>
          <div class="item-value">
            <el-input
              disabled
              placeholder="请输入..."
              v-model="phone"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">验证码：</div>
          <div class="item-value">
            <el-input
              placeholder="请输入"
              v-model="code"
              style="width: 150px; margin-right: 12px"
            ></el-input>
            <jd-button
              type="blue"
              :disabled="codeDisabled"
              @click="getCodeInit"
              >{{ codeMsg }}</jd-button
            >
          </div>
        </div>
        <div class="form-item" style="margin-bottom: 8px">
          <div class="form-item" style="margin-bottom: 8px">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="tip-box" style="background: #fff"></div>
            </div>
          </div>
        </div>
      </div>
    </jd-dialog>

    <!-- 加购详情弹窗 -->
    <jd-dialog
      title="加购详情"
      width="650px"
      :visible.sync="addCartDetailShow"
      @close="addCartDetailShow = false"
      :isShowSure="false"
      :isShowCancel="false"
    >
      <jdTable
        :tableData="addCartDetailData"
        :tableInfo="addCartDetailColumns"
        :loading="loading"
      >
        <template #product="{ scope }">
          <div class="addCartDetail">
            <div><img :src="scope.row.logo" /></div>
            <div>
              <div>{{ scope.row.title }}</div>
              <div>skuid：{{ scope.row.skuId }}</div>
            </div>
          </div>
        </template>
      </jdTable>
    </jd-dialog>

    <jd-dialog
      title="修改收货信息"
      width="420px"
      class="system-dialog"
      :visible.sync="lockTakeGoodsVisible"
      @close="lockTakeGoodsVisible = false"
      @confirm="setTakeGoods"
    >
      <div class="form-box new-input-box">
        <div class="form-item">
          <div class="item-label">姓名</div>
          <div class="item-value">
            <el-input
              placeholder="请输入..."
              v-model="takeGoodsForm.receiverName"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">手机号码</div>
          <div class="item-value">
            <el-input
              placeholder="请输入..."
              v-model="takeGoodsForm.receiverMobile"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">地区</div>
          <div class="item-value">
            <el-input
              placeholder="请输入..."
              v-model="takeGoodsForm.receiverAddress"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">详细地址</div>
          <div class="item-value">
            <el-input
              placeholder="请输入..."
              v-model="takeGoodsForm.detailedAddress"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
      </div>
    </jd-dialog>

    <lock-batch-dialog
      v-if="batchLockVisible"
      :visible="batchLockVisible"
      :activityId="rowData.id"
      @close="batchLockClose"
    ></lock-batch-dialog>
    
    <!-- 录入快递单号弹窗 -->
    <jd-dialog
      title="录入快递单号"
      width="420px"
      class="enter_coutier_num_dialog"
      :visible.sync="enterCoutierNumShow"
      @close="blankEnterCoutierNum"
      @confirm="enterCoutierSubmit"
    >
      <el-form :model="enterCoutierFrom" label-width="86px" class="new-input-box">
        <el-form-item label="快递单号：">
          <el-input
            placeholder=""
            v-model="enterCoutierNum"
            style="width: 250px"
            @keydown.native="clearInput"
          ></el-input>
        </el-form-item>
      </el-form>
    </jd-dialog>

    <!-- 批量标记发货 -->
    <batch-upload
      v-if="batchMarkVisible"
      :visible="batchMarkVisible"
      action="/jd-hd-web/PointActivityAnalyticController/markingSendStatusBatch/fileUpload"
      @close="batchMarkClose"
    ></batch-upload>

    <!-- 打榜有礼： 批量发货弹窗 -->
    <jd-dialog
      title="批量发货"
      width="580px"
      :visible.sync="physicalBatchShipmentShow"
      @close="physicalBatchShipmentClose"
      class="physical_batch_shipment_dialog"
      :isShowSure="false"
    >
      <el-form :model="physicalBatchShipmentFrom" label-width="120px" class="new-input-box">
        <el-form-item label="上传文件：">
          <el-upload
            :before-upload="beforeUploadFile"
            :on-success="handleUpload"
            :show-file-list="false"
            :data="fitersChooseIF([36])?
            { activityId: activityId } :
            { activityId: activityId, type: 1 }"
            class="upload-demo"
            :drag="true"
            multiple
            with-credentials
            :action="'/jd-hd-web/lockRight/markingSendStatusBatch/fileUpload'"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <!-- 下载模板按钮 -->
      <div class="download_template_box">
        <jd-button type="break" @click="handleDownloadTemplate"
          >下载模板</jd-button
        >
      </div>
      <div class="downloadMsgBox">
        <p>
          导入成功{{ downloadResData.successNum }}条，导入失败{{
            downloadResData.failNum
          }}条，导入失败相关{{fitersChooseIF([36]) ? "用户PIN": "用户昵称"}}：
        </p>
        <div class="downloadUser">
          <div
            class="downloaditem"
            v-for="(item, index) in downloadUserList"
            :key="index"
          >
            {{ index + 1 + ". " }}{{ item }}
          </div>
        </div>
      </div>
    </jd-dialog>

    <!-- 打榜有礼实物发货弹窗 -->
    <jd-dialog
      title="发货信息"
      width="420px"
      v-if="sendOutGoodsShow"
      :visible.sync="sendOutGoodsShow"
      @close="blankEnterCoutierNum"
      class="enter_coutier_num_dialog"
      @confirm="goodsEnterCoutierSubmit"
      :isShowCancel="false"
    >
      <el-form :model="sendOutGoodsForm" label-width="86px" class="new-input-box">
        <el-form-item label="快递单号">
          <el-input
            placeholder="请输入"
            v-model="enterCoutierNum"
            style="width: 280px"
            @keydown.native="clearInput"
          ></el-input>
        </el-form-item>
      </el-form>
    </jd-dialog>

    <!-- 生成人群 -->
    <crowdDialog v-if="isShowCrowdDialog" 
      :isShowCrowdDialog="isShowCrowdDialog" 
      :searchForm="crowCondition" 
      :activityType="rowData.activityType"
      :source="source"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      @close="crowdClose" 
    />
    <!-- 生成报表 -->  
    <generate 
      :control = 'control1' 
      v-if="control1" 
      @transData="(val) => (control1 = val)"
      @transData1 = 'getphone1'
    ></generate>
    <generate 
      :control = 'control2' 
      v-if="control2" 
      @transData="(val) => (control2 = val)"
      @transData1 = 'getphone2'
    ></generate>
    <generate 
      :control = 'control3' 
      v-if="control3" 
      @transData="(val) => (control3 = val)"
      @transData1 = 'getphone3'
    ></generate>
    <generate 
      :control = 'control4' 
      v-if="control4" 
      @transData="(val) => (control4 = val)"
      @transData1 = 'getphone4'
    ></generate>
    <div class="bigImg" v-if="dialogImageUrl">
      <img :src="dialogImageUrl" alt="">
      <i class="el-icon-circle-close" @click="closeBigImg"></i>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import generate from '@/components/generate_report.vue'
import inputForm from "@/components/jhk/inputForm";
import evaluationDialog from "./evaluationDialog/evaluationDialog.vue";
import lockBatchDialog from "./lockBatchDialog.vue";
import crowdDialog from "./crowd-Dialog.vue"
import batchUpload from '../list/components/batchUpload.vue'
import {
  getCoupon,
  openCardRecord,
  appointment,
  lockSendStatus,
  updateReceiveAddress,
  markingSendStatusLockRight
} from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import {
  memConvAnalysis,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import {
  markingSendStatus
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import statisticsData from "@/mixin/activity_statistics.js";

export default {
  mixins: [statisticsData],
  components: {
    inputForm,
    evaluationDialog,
    lockBatchDialog,
    crowdDialog,
    generate,
    batchUpload
  },
  props: {
    rowData: {
      type: Object,
      default: {},
    },
    ids1: {
      type: String,
      default: "",
    },
    // 用于区分是不是打榜有礼
    isChongBang: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      conversionData: [],
      //分页
      conversionPage: {
        current: 1,
        size: 10,
        total: 0,
      },
      //入会用户转化分析 
      conversionForm: {
        statDaysNum: 30,
        statType: 0,
        compareType: 0,
        orderAmount: null,
      },
      //入会用户转化分析
        inputConversionInfo: [
        {
          label: "统计活动入会后：",
          slot: "statDaysNum",
        },
        {
          label: "订单金额：",
          slot: "orderMoney",
        },
        {
          label: "入会时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "openCardStartTime",
          endKey: "openCardEndTime",
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
          defalutLimit: true,
          startTime: this.getDateStr(-30) + " 00:00:00",
          endTime: this.getDateStr(0) + " 23:59:59",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
          notShow: this.fitersChooseIF([19,46]) ? false : true
        },
      ],
      nowActType: 0,
      dialogImageUrl: "",
      source: "",
      crowdSearchForm: {},
      control1: false,
      control2: false,
      control3: false,
      control4: false,
      control5: false,
      control6: false,
      isShowCrowdDialog: false,
      lockTakeGoodsVisible: false,
      takeGoodsForm: {
        id: null,
        receiverName: "",
        receiverMobile: "",
        receiverAddress: "",
        detailedAddress: "",
      },
      batchLockVisible: false,
      // 收货信息
      takeGoodsTable: [],
      totalTakeGoods: 0,
      // note--锁权记录
      lockRightTable: [],
      totalLockRight: 0,
      // note--加购记录
      addCartTable: [],
      totalAddCart: 0,
      // 加购记录-表单配置
      inputDataAddCartFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'isWin',
          label: '中奖状态：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: '全部', value: '' },
            { label: '已中奖', value: 1 },
            { label: '未中奖', value: 0 },
          ]
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '加购时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
        }
      ],
      // 加购记录-表格配置
      addCartTableColumns: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick"
        },
        {
          label: "加购时间",
          prop: "addCartTime"
        },
        {
          label: "当前加购件数",
          prop: "addCartNum"
        },
        {
          label: "是否满足领奖条件",
          prop: "isAllowGetPrize",
          slot: "isAllowGetPrize"
        },
        {
          label: "是否中奖",
          prop: "isWin",
          slot: "isWin"
        },
        {
          label: "操作",
          prop: "action",
          slot: "action"
        }
      ],
      // 加购详情-表格配置
      addCartDetailColumns: [
        {
          label: "商品",
          prop: "product",
          slot: "product"
        },
        {
          label: "加购时间",
          prop: "addCartTime",
          width: "200"
        }
      ],
      // 加购记录查询条件
      inputDataAddCart: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "中奖状态:",
          val: "isWin",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", defaultValue: "", id: "" },
            { label: "已中奖", id: 1 },
            { label: "未中奖", id: 0 },
          ],
        },
        {
          name: "加购时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      // 弹窗
      addCartDetailShow: false,
      addCartDetailData: [],
      // note--结束
      dialogDeatils: false,
      isTaskPrize: false, // 是否为任务奖品类型
      taskIndex: "", // 任务标值
      CouponMember1: [],
      RuleFieldsList: [],
      multipleSelection: [],
      tableShopData: [],
      dialogGroup: false,
      dataSummary: [
        {
          value: "actPv", // 对应tableTotal的字段
          name: "活动PV",
          tips: true, // 提示的显示隐藏
          tipsName: "活动页面访问次数，刷新一次或点击一次都算一次PV流量。", // 提示语
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "actUv",
          name: "活动UV",
          tips: true,
          tipsName:
            "活动页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。",
          color: "#B2A8DA",
        },
        {
          value: "participateUv",
          name: "参与人数",
          tips: true,
          tipsName: "参与活动的人数。",
          color: "#F2D0B5",
        },
        {
          value: "participatePv",
          name: "参与次数",
          tips: true,
          tipsName: "参与活动的次数。",
          color: "#F4ACB9",
        },
        {
          value: "participateAvg",
          name: "人均参与次数",
          tips: true,
          tipsName: "参与次数/参与人数。",
          color: "#C2CDDE",
        },
        {
          value: "shareUv",
          name: "分享人数",
          tips: false,
          tipsName: "",
          color: "#A7878E",
        },
        {
          value: "sharePv",
          name: "分享次数",
          tips: false,
          tipsName: "",
          color: "#B8C7F3",
        },
        {
          value: "scanshopUv",
          name: "浏览店铺人数",
          tips: false,
          tipsName: "",
          color: "#CAC7A1",
        },
        {
          value: "scanshopPv",
          name: "浏览店铺次数",
          tips: false,
          tipsName: "",
          color: "#E57733",
        },
        {
          value: "cartUv",
          name: "加购人数",
          tips: false,
          tipsName: "",
          color: "#D39595",
        },
        {
          value: "cartPv",
          name: "加购次数",
          tips: false,
          tipsName: "",
          color: "#C2D1C8",
        },
        {
          value: "followshopUv",
          name: "新增粉丝人数",
          tips: false,
          tipsName: "",
          color: "#BB7495",
        },
        {
          value: "followshopPv",
          name: "新增粉丝次数",
          tips: false,
          tipsName: "",
          color: "#96AA08",
        },
        {
          value: "followskuUv",
          name: "新增商品关注人数",
          tips: false,
          tipsName: "",
          color: "#77B2BD",
        },
        {
          value: "followskuPv",
          name: "新增商品关注次数",
          tips: false,
          tipsName: "",
          color: "#D6BF50",
        },
      ],
      tatal_num: {
        users: 0, //活动参与用户15天内下单用户量
        ordNum: 0, //活动参与⽤户15天内下单订单总量
        gmv: 0, //活动参与⽤户15天内下单转化金额(元)
        ordRate: 0, //活动参与⽤户15天内下单转化率
      },
      hostList: [
        {
          name: "下单用户量",
          nameOne: 100,
        },
        {
          name: "下单订单总量",
          nameOne: 100,
        },
        {
          name: "下单金额",
          nameOne: 100,
        },
        {
          name: "下单转化率",
          nameOne: 100,
        },
      ],
      loading: false,
      activeName: "first",
      activityTable: [],
      goodsRecordTable:[],
      getRecordList:[],
      signInTable: [],
      awardTable: [],
      awardTable1: [
        {
          a: 1,
        },
      ],
      distributionTable: [],
      inkindTable: [],
      userInfoTable: [],
      GiftrecordList: [],
      invitationNum: [], //邀请统计
      queryForm: {
        evaluateTime: "7",
      },
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "15",
            label: "近15天",
          },
          {
            value: "30",
            label: "近30天",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      postForm: {
        startDate: "",
        endDate: "",
        channelCode: "",
      },
      batchTypeList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "商品详情",
          value: 1001,
        },
        {
          label: "店铺首页",
          value: 1002,
        },
        {
          label: "会员二级页",
          value: 1003,
        },
        {
          label: "推广页",
          value: 1004,
        },
        {
          label: "其他",
          value: 1005,
        },
      ],
      tableTotal: {
        pv: 0, //会员中心首页PV
        uv: 0, //会员中心首页uv
        // incrJoinNumber: [], //参与人数今日增量
        joinNumber: 0, //参与人数
        joinTimes: 0, //参与人次
        perJoinNumber: 0, //人均参与次数
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.startDate) {
            return time.getTime() < new Date(this.postForm.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.endDate) {
            return time.getTime() > new Date(this.postForm.endDate).getTime();
          } else {
          }
        },
      },
      //折线图数据
      loading1: false,
      myCharts: null,
      chartEffectDetail: [],
      // 过滤后的折线图数据
      filteredChartEffectDetail: [],
      totalNum: 0,
      totalAward: 0,
      totalSignIn: 0,
      totalInkind: 0,
      totalUserInfo: 0,
      totalDistribution: 0, //发放记录
      totalCoupon: 0,
      totalCouponstatistics: 0,
      totalTeam: 0,
      totalComment: 0,
      totalParticipat: 0,
      totalParticipatLock: 0,
      totalGiftrecord: 0,
      totalAwardFor: 0,
      totalRecord:0,
      inviteeDetailsTotal: 0,
      formList: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      activityId: this.rowData.id,
      formList1: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      formListRecord:{
        size: 10,
        current: 1,
        activityId: this.rowData.id
      },
      formListLock: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      // 签到记录-表单配置
      inputSignInFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '签到时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
        }
      ],
      // 签到记录-表格配置
      signInTableColumns: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick",
          width: "400"
        },
        {
          label: "签到时间",
          prop: "signTime",
          width: "400"
        },
        {
          label: "累计签到次数(含历史记录)",
          prop: "cumulativeTimes",
          width: "400"
        },
        {
          label: "连续签到次数(不含历史记录)",
          prop: "sequenceTimes"
        }
      ],
      // 参与记录-表单配置
      inputParticipatFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '参与时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
        },
        {
          type: 'InputDouble',
          startKey: 'startScore',
          endKey: 'endScore',
          label: '得分：',
          startPlaceholder: '请输入',
          endPlaceholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'isPass',
          label: '是否通关：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: '全部', value: '' },
            { label: '是', value: 1 },
            { label: '否', value: 0 }
          ]
        },
        {
          type: 'Select',
          prop: 'isDraw',
          label: '是否抽奖：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: '全部', value: '' },
            { label: '是', value: 1 },
            { label: '否', value: 0 }
          ]
        },
        {
          type: 'Select',
          prop: 'isWin',
          label: '是否中奖：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: '全部', value: '' },
            { label: '是', value: 1 },
            { label: '否', value: 0 }
          ]
        }
      ],
      // 参与记录-表格配置1
      participatTableColumns1: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick"
        },
        {
          label: "参与时间",
          prop: "joinTime"
        },
        {
          label: "得分",
          prop: "score",
          slot: 'score',
        },
        {
          label: "是否通关",
          prop: "isPass",
          slot: 'isPass'
        },
        {
          label: "是否抽奖",
          prop: "isDraw",
          slot: 'isDraw'
        },
        {
          label: "是否中奖",
          prop: "isWin",
          slot: 'isWin'
        }
      ],
      // 参与记录-表格配置2
      participatTableColumns2: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick"
        },
        {
          label: "参与时间",
          prop: "joinTime"
        },
        {
          label: "是否通关",
          prop: "isPass",
          slot: 'isPass'
        },
        {
          label: "是否抽奖",
          prop: "isDraw",
          slot: 'isDraw'
        },
        {
          label: "是否中奖",
          prop: "isWin",
          slot: 'isWin'
        }
      ],
      // 积分锁权-参与记录表单配置
      inputParticipatLockFormInfo: [
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'isPass',
          label: '是否符合中奖条件：',
          placeholder: '请选择',
          value:'',
          options: [
            { label: '全部', value: '' },
            { label: '符合', value: 1 },
            { label: '不符合', value: 0 }
          ]
        },
        {
          type: 'Select',
          prop: 'isWin',
          label: '是否领取奖品：',
          placeholder: '请选择',
          value:'',
          options: [
            { label: '全部', value: '' },
            { label: '已领取', value: 1 },
            { label: '未领取', value: 0 }
          ]
        },
        {
          type: 'DateRange',
          startKey: 'createStartTime',
          endKey: 'createEndTime',
          label: '参与时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
        },
        {
          type: 'DateRange',
          startKey: 'winStartTime',
          endKey: 'winEndTime',
          label: '领奖时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
        }
      ],
      // 积分锁权-参与记录表格配置
      participatLockTableColumns: [
        {
          label: "用户昵称",
          prop: "memberNick"
        },
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "参与时间",
          prop: "createTime"
        },
        {
          label: "是否符合中奖条件",
          prop: "isPass",
          slot: 'isPass'
        },
        {
          label: "订单金额",
          prop: "buyMoney"
        },
        {
          label: "商品件数",
          prop: "itemTotal"
        },
        {
          label: "是否领取奖品",
          prop: "isWin",
          slot: 'isWin'
        },
        {
          label: "领奖时间",
          prop: "winTime"
        }
      ],
      // 打榜有礼-领奖记录-表单配置
      inputAwardFiftenFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'rank',
          label: '中奖名次：',
          placeholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'prizeType',
          label: '奖品类型：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: '未知', value: 0 },
            { label: '优惠券', value: 1 },
            { label: '京豆', value: 2 },
            { label: '实物', value: 3 },
            { label: '店铺积分', value: 4 },
            { label: '京豆E卡', value: 5 },
            { label: '爱奇艺会员', value: 6 },
            { label: '京豆PLUS会员', value: 7 },
            { label: '现金红包', value: 8 },
            { label: '谢谢参与', value: 9 },
          ]
        },
        {
          type: 'Select',
          prop: 'status',
          label: '中奖状态：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: '未中奖', value: 1 },
            { label: '已中奖', value: 2 },
            { label: '已发放', value: 3 },
            { label: '发放失败', value: 4 },
            { label: '待发放', value: 7 },
          ]
        },
        {
          type: 'DateRange',
          startKey: 'createTimeStart',
          endKey: 'createTimeEnd',
          label: '参与时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: true,
        },
        {
          type: 'DateRange',
          startKey: 'sendTimeStart',
          endKey: 'sendTimeEnd',
          label: '发放时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: true,
        }
      ],
      // 打榜有礼-领奖记录-表格配置
      chongBangAwardTableColumns: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick",
          width: "170"
        },
        {
          label: "活动名称",
          prop: "activityName",
          width: "170"
        },
        {
          label: "总订单金额（已付款）",
          prop: "totalPayMoney",
          width: "180",
          slotHead: "totalPayMoneyHeader"
        },
        {
          label: "总订单笔数（已付款）",
          prop: "orderPayNum",
          width: "180"
        },
        {
          label: "总订单金额（已收货）",
          prop: "totalFinishMoney",
          width: "180",
          slotHead: "totalFinishMoneyHeader"
        },
        {
          label: "总订单笔数（已收货）",
          prop: "orderFinishNum",
          width: "180"
        },
        {
          label: "名次",
          prop: "rank"
        },
        {
          label: "奖品类型",
          prop: "prizeTypeStr",
           width: "80"
        },
        {
          label: "奖品名称",
          prop: "prizeName",
           width: "160"
        },
        {
          label: "订单号",
          prop: "orderIdStr",
          slot: "orderIdStr",
          width: "160"
        },
        {
          label: "中奖状态",
          prop: "statusStr",
           width: "80"
        },
        {
          label: "参与时间",
          prop: "joinTime",
          width: "200"
        },
        {
          label: "领奖时间",
          prop: "winTime",
          width: "200"
        },
        {
          label: "发放时间",
          prop: "grantTime",
          width: "200"
        },
        {
          label: "操作",
          prop: "action",
          width: "200",
          slot: "chongBangAction"
        }
      ],
      // 派样下订单记录表
      inputSendBuyPayFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'skuId',
          label: '商品SKU：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'skuName',
          label: '商品名称：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'orderId',
          label: '订单号：',
          placeholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'isCommitAddress',
          label: '录入收货信息：',
          placeholder: '请选择',
          options: [
            { label: '全部', value: null },
            { label: '是', value: 1 },
            { label: '否', value: 0 }
          ]
        },
        {
          type: 'DateRange',
          startKey: 'orderTimeStart',
          endKey: 'orderTimeEnd',
          label: '付款时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
        },
        {
          type: 'DateRange',
          startKey: 'receiveTimeStart',
          endKey: 'receiveTimeEnd',
          label: '收货时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
        }
      ],
      // 派样下单表格配置
      sendBuyPayTableColumns: [
        {
          prop: "chaosPin",
          label: "用户pin(加密)",
          width: 150
        },
        {
          prop: "activityName",
          label: "活动名称"
        },
        {
          prop: "shopNameDetail",
          label: "商品信息",
          slot: "shopNameDetail"
        },
        {
          label: "订单号",
          prop: "orderId"
        },
        {
          label: "付款时间",
          prop: "orderStartTime"
        },
        {
          label: "收货时间",
          prop: "orderEndTime"
        },
        {
          prop: "isCommitAddress",
          label: "是否录入收货信息",
          slot: "isCommitAddress"
        }
      ],
      // 派样下单记录表格数据
      sendBuyPayTable: [],
      // 派样下单表格总数
      totalSendBuyPayCount: 0,
      // 回购下单表格配置
      inputSendBuyRePayFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'skuId',
          label: '商品SKU：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'skuName',
          label: '商品名称：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'orderId',
          label: '订单号：',
          placeholder: '请输入',
        },
        {
          type: 'InputDouble',
          startKey: 'orderPaymentStart',
          endKey: 'orderPaymentEnd',
          label: '商品金额：',
          startPlaceholder: '请输入',
          endPlaceholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'isWin',
          label: '是否中奖：',
          placeholder: '请选择',
          options: [
            { label: '是', value: 1 },
            { label: '否', value: 0 }
          ]
        },
        {
          type: 'Select',
          prop: 'isCommitAddress',
          label: '录入收货信息：',
          placeholder: '请选择',
          options: [
            { label: '全部', value: null },
            { label: '是', value: 1 },
            { label: '否', value: 0 }
          ]
        },
        {
          type: 'DateRange',
          startKey: 'orderTimeStart',
          endKey: 'orderTimeEnd',
          label: '付款时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
        },
        {
          type: 'DateRange',
          startKey: 'receiveTimeStart',
          endKey: 'receiveTimeEnd',
          label: '收货时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
        }
      ],
      // 回购下单表格配置
      sendBuyRePayTableColumns: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "活动名称",
          prop: "activityName"
        },
        {
          label: "订单号",
          prop: "orderId"
        },
        {
          label: "商品金额",
          prop: "orderPayment"
        },
        {
          label: "商品信息",
          prop: "shopNameDetail",
          slot: 'shopNameDetail'
        },
        {
          label: "付款时间",
          prop: "orderStartTime"
        },
        {
          label: "收货时间",
          prop: "orderEndTime"
        }
        ,
        {
          label: "是否录入收货信息",
          prop: "isCommitAddress",
          slot: 'isCommitAddress'
        },
        {
          label: "是否中奖",
          prop: "isWin",
          slot: 'isWin'
        }
      ],
      // 回购下单记录表格数据
      sendBuyRePayTable: [],
      // 回购下单表格总数
      totalSendBuyRePayCount: 0,

      // 锁权记录-表单配置
      inputLockRightFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Select',
          prop: 'isPass',
          label: '满足中奖门槛：',
          placeholder: '请选择',
          value: null,
          options: [
            { label: '全部', value: null },
            { label: '是', value: 1 },
            { label: '否', value: 0 },
          ]
        },
        {
          type: 'Select',
          prop: 'isEnter',
          label: '录入收货信息：',
          placeholder: '请选择',
          value: null,
          options: [
            { label: '全部', value: null },
            { label: '是', value: 1 },
            { label: '否', value: 0 },
          ]
        },
        {
          type: 'InputDouble',
          startKey: 'buyOrderNumMin',
          endKey: 'buyOrderNumMax',
          label: '下单期间订单数：',
          startPlaceholder: '请输入',
          endPlaceholder: '请输入',
        },
        {
          type: 'InputDouble',
          startKey: 'buyMoneyMin',
          endKey: 'buyMoneyMax',
          label: '下单期间总额：',
          startPlaceholder: '请输入',
          endPlaceholder: '请输入',
        },
        {
          type: 'DateRange',
          startKey: 'createTimeStart',
          endKey: 'createTimeEnd',
          label: '锁权时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
        }
      ],
      // 锁权记录-表格配置
      lockRightTableColumns: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "活动名称",
          prop: "activityName"
        },
        {
          label: "锁权积分",
          prop: "point"
        },
        {
          label: "活动下单期间购买金额",
          prop: "buyMoney"
        },
        {
          label: "活动下单期间购买订单数",
          prop: "buyOrder"
        },
        {
          label: "是否符合中奖门槛",
          prop: "isPassStr"
        },
        {
          label: "是否录入收货信息",
          prop: "isEnterStr"
        },
        {
          label: "锁权时间",
          prop: "createTime"
        }
      ],
      inputLockRight: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入用户PIN",
        },
        {
          name: "满足中奖门槛:",
          val: "isPass",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "录入收货信息:",
          val: "isEnter",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "下单期间订单数:",
          iptArr: [
            { val: "buyOrderNumMin", placeholder: "请输入" },
            { val: "buyOrderNumMax", placeholder: "请输入" },
          ],
        },
        {
          name: "下单期间总额:",
          iptArr: [
            { val: "buyMoneyMin", placeholder: "请输入" },
            { val: "buyMoneyMax", placeholder: "请输入" },
          ],
        },
        {
          name: "锁权时间:",
          myDate: true,
          val: ["createTimeStart", "createTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      // 锁权和派样回购-收货信息-表单配置
      inputTakeGoodsFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'DateRange',
          startKey: 'inputTimeStart',
          endKey: 'inputTimeEnd',
          label: '录入时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: true,
        }
      ],
      // 锁权和派样回购-收货信息-表格配置
      takeGoodsTableColumns: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "活动名称",
          prop: "activityName"
        },
        {
          label: "姓名",
          prop: "memberNick",
          slot: "memberNick"
        },
        {
          label: "手机号码",
          prop: "mobile",
          width: "120",
          slot: "mobile"
        },
        {
          label: "地区",
          prop: "receiverAddress",
          width: "210",
          slot: "receiverAddress"
        },
        {
          label: "详细地址",
          prop: "detailedAddress",
          width: "210",
          slot: "detailedAddress"
        },
        {
          label: "录入时间",
          prop: "inputTime"
        },
        {
          label: "操作",
          prop: "action",
          width: "100",
          slot: "actionTakeGoods"
        }
      ],
      // 发放记录-表单配置
      inputAwardOneFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'status',
          label: '发放状态：',
          placeholder: '请选择',
          options: [
            { label: '已发放', value: 3 },
            { label: '发放失败', value: 4 },
          ]
        },
        {
          type: 'Select',
          prop: 'prizeType',
          label: '奖品类型：',
          placeholder: '请选择',
          options: [
            { label: '优惠券', value: 1 },
            { label: '京豆', value: 2 },
            { label: '店铺积分', value: 4 },
          ]
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '参与时间：',
          dateType: 'datetime',
          defalutLimit: true,
          format: 'yyyy-MM-dd HH:mm:ss',
        },
      ],
      // 中奖记录-表单配置
      inputAwardTwoFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '预约时间：',
          dateType: 'datetime',
          defalutLimit: true,
          format: 'yyyy-MM-dd HH:mm:ss',
        },
        {
          type: 'Select',
          prop: 'status',
          label: '发货状态：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: '全部', value: '' },
            { label: '未发货', value: '2,7' },
            { label: '已发货', value: '5' },
          ]
        },
        {
          type: 'Select',
          prop: 'isFillAddress',
          label: '是否填写地址：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: '全部', value: '' },
            { label: '已填写', value: 1 },
            { label: '未填写', value: 0 },
          ]
        }
      ],
      // 中奖记录-表格配置
      awardTableColumns: [
        {
          type: "selection",
          width: "55"
        },
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick",
          width: "180"
        },
        {
          label: "奖品名称",
          prop: "prizeTitle",
          width: "180"
        },
        {
          label: "是否填写地址",
          prop: "isFillAddress",
          width: "180"
        },
        {
          label: "预约时间",
          prop: "joinTime",
          width: "280"
        },
        {
          label: "发货时间",
          prop: "grantTime",
          width: "280"
        },
        {
          label: "发货状态",
          prop: "status",
          slot: "deliveryStatus"
        },
        {
          label: "收件人",
          prop: "receiverName",
          slot: "receiverName"
        },
        {
          label: "收件人手机号",
          prop: "receiverMobile",
          width: "120",
          slot: "receiverMobile"
        },
        {
          label: "收件人地址",
          prop: "receiverAddress",
          width: "210",
          slot: "receiverAddress"
        },
        {
          label: "收件人详细地址",
          prop: "detailedAddress",
          width: "210",
          slot: "detailedAddress"
        },
        {
          label: "操作",
          prop: "action",
          slot: "action"
        }
      ],
      // 邀请统计-表单配置
      InputAwardThreeFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '发起时间：',
          dateType: 'datetime',
          defalutLimit: true,
          format: 'yyyy-MM-dd HH:mm:ss',
        },
      ],
      // 中奖记录-积分锁权-表单配置
      inputAwardFourFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'mobile',
          label: '手机号码：',
          placeholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'sendStatus',
          label: '发放状态：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: '待发放', value: 0 },
            { label: '已发放', value: 1 },
            { label: '已失效', value: 2 },
          ]
        },
        {
          type: 'Select',
          prop: 'deliveryStatus',
          label: '发货状态：',
          placeholder: '请选择',
          options: [
            { label: '未发货', value: 0 },
            { label: '已发货', value: 1 },
          ]
        },
        {
          type: 'DateRange',
          startKey: 'createTimeStart',
          endKey: 'createTimeEnd',
          label: '创建时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: true,
        },
        {
          type: 'DateRange',
          startKey: 'sendTimeStart',
          endKey: 'sendTimeEnd',
          label: '发放时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: true,
        },
        {
          type: 'DateRange',
          startKey: 'deliveryTimeStart',
          endKey: 'deliveryTimeEnd',
          label: '发货时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: true,
        }
      ],
      // 中奖记录-积分锁权-表格配置
      awardTableFourColumns: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "活动名称",
          prop: "activityName"
        },
        {
          label: "姓名",
          prop: "memberNick",
          slot: "memberNick"
        },
        {
          label: "手机号码",
          prop: "mobile",
          width: "120",
          slot: "mobile"
        },
        {
          label: "地区",
          prop: "receiverAddress",
          width: "210",
          slot: "receiverAddress"
        },
        {
          label: "详细地址",
          prop: "detailedAddress",
          width: "210",
          slot: "detailedAddress"
        },
        {
          label: "发放状态",
          prop: "sendStatusStr"
        },
        {
          label: "创建时间",
          prop: "createTime"
        },
        {
          label: "发放时间",
          prop: "sendTime"
        },
        {
          label: "发货状态",
          prop: "deliveryStatusStr"
        },
        {
          label: "快递单号",
          prop: "billCode"
        },
        {
          label: "发货时间",
          prop: "deliveryTime"
        },
        {
          label: "操作",
          prop: "action",
          width: "100",
          slot: "actionFour"
        }
      ],
      inputInkind: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入用户PIN",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: this.fitersRepurchase(
            [16, 17, 18, 27, 28, 19],
            "领奖时间:",
            "中奖时间:"
          ),
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发货状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "已发货", id: "5" },
            { label: "未发货", id: "2,7" },
          ],
        },
        {
          name: "是否提交地址",
          val: "commitAddressFlag",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" ,defaultValue: ""},
            { label: "已提交", id: 1 },
            { label: "未提交", id: 0 },
          ],
        },
      ],
      // 实物奖品-表单配置
      inputInkindFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: this.fitersRepurchase(
            [16, 17, 18, 27, 28, 19],
            "领奖时间：",
            "中奖时间："
          ),
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: true,
        },
        {
          type: 'Select',
          prop: 'status',
          label: '发货状态：',
          placeholder: '请选择',
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已发货", value: "5" },
            { label: "未发货", value: "2,7" },
          ],
        },
        {
          type: 'Select',
          prop: 'commitAddressFlag',
          label: '是否提交地址：',
          placeholder: '请选择',
          value:"",
          options: [
            { label: "全部", value: "" },
            { label: "已提交", value: 1 },
            { label: "未提交", value: 0 },
          ],
        },
      ],
      inputInkidNeedAwardFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: this.rowData.activityType==41 ? '发货时间：' : this.fitersRepurchase(
            [16, 17, 18, 27, 28, 19],
            "领奖时间：",
            "中奖时间："
          ),
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: true,
        },
        {
          type: 'Select',
          prop: 'status',
          label: '发货状态：',
          placeholder: '请选择',
          options: [
            { label: "全部", value: '' },
            { label: "已发货", value: "5" },
            { label: "未发货", value: "2,7" },
          ],
        },
        {
          type: 'Select',
          prop: 'commitAddressFlag',
          label: '是否提交地址：',
          placeholder: '请选择',
          value:"",
          options: [
            { label: "全部", value: "" },
            { label: "已提交", value: 1 },
            { label: "未提交", value: 0 },
          ],
        },
        {
          type: 'Select',
          prop: 'orderState',
          label: '关联订单状态：',
          placeholder: '请选择',
          value:"",
          options: [
            { label: "全部", value: "" },
            { label: "等待付款", value: "等待付款" },
            { label: "暂停", value: "暂停" },
            { label: "等待出库", value: "等待出库" },
            { label: "等待发货", value: "等待发货" },
            { label: "完成", value: "完成" },
            { label: "取消", value: "取消" },
            { label: "锁定", value: "锁定" },
            { label: "等待确认收货", value: "等待确认收货" },
            { label: "未知", value: "未知" },
          ],
        },
        {
          type: 'Input',
          prop: 'orderId',
          label: '订单号：',
          placeholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'prizeStatus',
          label: this.fitersRepurchase(
            [19, 28],
            "中奖状态：",
            "发放状态："
          ),
          placeholder: '请选择',
          options: this.fitersRepurchase(
            [19, 28],
            [
              { label: "全部", value: "" },
              { label: "未中奖", value: 1 },
              { label: "已中奖", value: 2 },
              { label: "已发放", value: 3 },
              { label: "发放失败", value: 4 },
              { label: "已失效", value: 8 },
            ],
            [
              { label: "全部", value: "" },
              { label: "待领取", value: -1 },
              { label: "待发放", value: 2 },
              { label: "已发放", value: 3 },
              { label: "发放失败", value: 4 },
              { label: "已失效", value: 8 },
            ]
          ),
        },
      ],
      inputInkidNeedAward: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: this.rowData.activityType==41 ? '发货时间' : this.fitersRepurchase(
            [16, 17, 18, 27, 28, 19],
            "领奖时间:",
            "中奖时间:"
          ),
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发货状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: '' ,defaultValue: ''},
            { label: "已发货", id: "5" },
            { label: "未发货", id: "2,7" },
          ],
        },
        {
          name: "是否提交地址",
          val: "commitAddressFlag",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "",defaultValue: "" },
            { label: "已提交", id: 1 },
            { label: "未提交", id: 0 },
          ],
        },
        {
          name: "关联订单状态:",
          val: "orderState",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "等待付款", id: "等待付款" },
            { label: "暂停", id: "暂停" },
            { label: "等待出库", id: "等待出库" },
            { label: "等待发货", id: "等待发货" },
            { label: "完成", id: "完成" },
            { label: "取消", id: "取消" },
            { label: "锁定", id: "锁定" },
            { label: "等待确认收货", id: "等待确认收货" },
            { label: "未知", id: "未知" },
          ],
        },
        {
          name: "订单号:",
          val: "orderId",
          placeholder: "请输入",
        },
        {
          name: this.fitersRepurchase(
            [19, 28],
            "中奖状态:",
            "发放状态:"
          ),
          val: "prizeStatus",
          placeholder: "请选择",
          selectArr:  this.fitersRepurchase(
            [19, 28],
            [
            { label: "全部", id: "",defaultValue: "" },
            { label: "未中奖", id: 1 },
            { label: "已中奖", id: 2 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
            { label: "已失效", id: 8 },
            ],
            [
            { label: "全部", id: "",defaultValue: "" },
            { label: "待领取", id: -1 },
            { label: "待发放", id: 2 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
            { label: "已失效", id: 8 },
            ]),
        },
      ],

      // 资料明细-表单配置
      inputUserInfoFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '时间范围：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: false,
        },
      ],
      // 资料明细-表格配置
      userInfoBaseColumns: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick",
          width: "150"
        },
        {
          label: "资料填写时间",
          prop: "createTime",
          align: "center"
        }
      ],
      userInfoDynamicColumns: [
        {
          label: "姓名",
          prop: "name",
          width: "150",
          slot: "name",
          fieldName: "姓名"
        },
        {
          label: "手机号",
          prop: "mobile",
          width: "150",
          slot: "mobile",
          fieldName: "手机号码"
        },
        {
          label: "生日",
          prop: "birthDay",
          width: "200",
          slot: "birthDay",
          fieldName: "生日"
        },
        {
          label: "QQ",
          prop: "qq",
          width: "150",
          slot: "qq",
          fieldName: "QQ"
        },
        {
          label: "微信",
          prop: "weChat",
          width: "150",
          slot: "weChat",
          fieldName: "微信"
        },
        {
          label: "性别",
          prop: "sex",
          width: "150",
          slot: "sex",
          fieldName: "性别"
        },
        {
          label: "职业",
          prop: "job",
          width: "150",
          slot: "job",
          fieldName: "职业"
        },
        {
          label: "地区",
          prop: "address",
          width: "150",
          slot: "address",
          fieldName: "地区"
        },
        {
          label: "详细地址",
          prop: "detailedAddress",
          width: "150",
          slot: "detailedAddress",
          fieldName: "详细地址"
        },
        {
          label: "扩展信息",
          prop: "extendInfo",
          width: "300",
          slot: "extendInfo",
          fieldName: "扩展信息"
        }
      ],
      // 拼券明细-表单配置
      InputCouponFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: this.fitersRepurchase([21], "领取时间：", "参与时间："),
          dateType: 'datetime',
          defalutLimit: true,
          format: 'yyyy-MM-dd HH:mm:ss',
        },
      ],
      // 优惠券统计-表格配置
      InputSplitCouponFormInfo: [
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '统计时间：',
          dateType: 'date',
          defalutLimit: true,
          format: 'yyyy-MM-dd',
        },
      ],
      // 团队详情-表单配置
      InputGroupCouponFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '统计时间：',
          dateType: 'datetime',
          defalutLimit: true,
          format: 'yyyy-MM-dd HH:mm:ss',
        },
      ],
      // 抽奖机会赠送记录-表单配置
      inputCommentFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'nickName',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'orderId',
          label: '订单号：',
          placeholder: '请输入',
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '评价时间：',
          dateType: 'datetime',
          defalutLimit: true,
          format: 'yyyy-MM-dd HH:mm:ss',
        },
        {
          type: 'Select',
          prop: 'filterType',
          label: '过滤状态：',
          placeholder: '请选择',
          options: [
            { label: '未通过', value: 0 },
            { label: '通过', value: 1 },
          ]
        },
      ],
      // 抽奖机会赠送记录-表格配置
      commentTableColumns: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "nickName"
        },
        {
          label: "评价时间",
          prop: "creationTime"
        },
        {
          label: "SKUID",
          prop: "skuId"
        },
        {
          label: "订单号",
          prop: "orderId"
        },
        {
          label: "过滤状态",
          prop: "filterType",
          slot: "filterType"
        },
        {
          label: "备注",
          prop: "filterRemark"
        },
        {
          label: "操作",
          prop: "action",
          width: "200",
          slot: "actionComment"
        }
      ],
      // 参与赠送记录-表单配置
      InputGiftrecordFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'taskType',
          label: '获赠类型：',
          placeholder: '请输入',
          options: [
            { label: "每日打卡", value: 1 },
            { label: "浏览店铺", value: 2 },
            { label: "浏览商品", value: 3 },
            { label: "加购商品", value: 4 },
            { label: "浏览会场", value: 5 },
            { label: "关注店铺", value: 6 },
            { label: "开卡入会", value: 7 },
            { label: "好友助力", value: 8 },
          ],
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '获赠时间：',
          dateType: 'datetime',
          defalutLimit: true,
          format: 'yyyy-MM-dd HH:mm:ss',
        },
      ],
      // 参与赠送记录-表单配置(大转盘)
      InputGiftrecord2FormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'taskType',
          label: '获赠类型：',
          placeholder: '请输入',
          options: [
            { label: "全部", value: "" },
            { label: "每日签到", value: 1 },
            { label: "浏览店铺", value: 2 },
            { label: "浏览商品", value: 13 },
            { label: "加购商品", value: 4 },
            { label: "分享商品", value: 9 },
            { label: "分享店铺", value: 10 },
            { label: "分享活动", value: 11 },
            { label: "好友助力", value: 8 },
            { label: "浏览会场", value: 5 },
            { label: "预约商品", value: 12 },
            { label: "首次赠送", value: 14 },
            { label: "每日赠送", value: 15 },
            { label: "积分兑换", value: 16 },
            { label: "购买商品", value: 17 },
          ],
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '获赠时间：',
          dateType: 'datetime',
          defalutLimit: true,
          format: 'yyyy-MM-dd HH:mm:ss',
        },
      ],

      // 被邀请人明细-表单配置
      InviteeDetailsFormInfo: [
        {
          type: 'Input',
          prop: 'invitePin',
          label: '邀请人用户PIN：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'inviteNick',
          label: '邀请人昵称：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'pin',
          label: '被邀请人用户PIN：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '被邀请人昵称：',
          placeholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'isValidInvite',
          label: '是否有效邀请：',
          placeholder: '请选择',
          options: [
            { label: '全部', value: '' },
            { label: '是', value: '1' },
            { label: '否', value: '0' },
          ],
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '邀请时间：',
          dateType: 'datetime',
          defalutLimit: true,
          format: 'yyyy-MM-dd HH:mm:ss',
        },
      ],
      // 被邀请人明细-表单配置
      inviteeDetailsTableColumns: [
        {
          label: "邀请人用户pin(加密)",
          prop: "inviteChaosPin",
          width: "200"
        },
        {
          label: "邀请人昵称",
          prop: "inviteNick",
          width: "200"
        },
        {
          label: "被邀请人用户pin(加密)",
          prop: "chaosPin",
          width: "200"
        },
        {
          label: "被邀请人昵称",
          prop: "memberNick",
          width: "150"
        },
        {
          label: "是否有效邀请",
          prop: "isValidInvite",
          width: "150",
          slot: "isValidInvite"
        },
        {
          label: "订单号",
          prop: "orderIds",
          width: "150",
          slot: "orderIds"
        },
        {
          label: "订单数",
          prop: "orderCount",
          width: "150",
          slot: "orderCount"
        },
        {
          label: "商品件数",
          prop: "itemCount",
          width: "150",
          slot: "itemCount"
        },
        {
          label: "付款金额",
          prop: "paymentAmount",
          width: "150",
          slot: "paymentAmount"
        },
        {
          label: "邀请时间",
          prop: "joinTime",
          width: "250",
          slot: "joinTime"
        }
      ],
      inviteeDetailsData: [],
      inviteeDetailsPage: {
        current:1,
        size:10,
        total:0
      },
      hasDefaultValue:false,
      defaultValueText:"",
      couponDetailsList: [],
      CouponStatisticsList: [],
      TeamDetailsList: [],
      CommentList: [],
      CouponMember: [],
      ParticipatTable: [],
      ParticipatLockTable: [],
      commentItem: {},
      commentDioag: false,

      dialogExprot: false,
      codeMsg: "获取验证码",
      code: "",
      phone: "",
      successMsg: "",
      // timer: "",
      countdown: 60,
      codeDisabled: false,
      ExprotData: "",
      // 验证码
      opentime: true,
      visible: false,
      timer: null, //验证码定时
      saveDisable: false,

      // 兑换记录-实物-表单配置
      InputDataThir9FormInfo: [
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入用户昵称',
        },
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '兑换时间：',
          dateType: 'datetime',
          defalutLimit: true,
          format: 'yyyy-MM-dd HH:mm:ss',
          lastDay: 30,
        },
        {
          type: 'Select',
          prop: 'exchangeStatus',
          label: '兑换状态：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: '全部', value: '' },
            { label: '兑换成功', value: 1 },
            { label: '兑换失败', value: 2 },
          ],
        },
        {
          type: 'Select',
          prop: 'deliveryStatus',
          label: '发货状态：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: '全部', value: '' },
            { label: '待发货', value: 1 },
            { label: '已发货', value: 2 },
          ],
        },
        {
          type: 'Select',
          prop: 'commitAddressFlag',
          label: '是否提交地址：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: '全部', value: '' },
            { label: '已提交', value: 1 },
            { label: '未提交', value: 0 },
          ],
        },
      ],
      // 兑换记录-实物-表格配置
      exchangeDetailTableColumns: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "200"
        },
        {
          label: "用户昵称",
          prop: "memberNick",
          width: "200"
        },
        {
          label: "中奖id",
          prop: "id"
        },
        {
          label: "礼品名称",
          prop: "prizeName",
          width: "200"
        },
        {
          label: "礼品类型",
          prop: "prizeType",
          width: "100",
          slot: "prizeType"
        },
        {
          label: "消耗积分",
          prop: "point",
          width: "120"
        },
        {
          label: "兑换时间",
          prop: "exchangeTime",
          width: "250"
        },
        {
          label: "兑换状态",
          prop: "exchangeStatus",
          width: "180",
          slot: "exchangeStatus"
        },
        {
          label: "发货状态",
          prop: "deliveryStatus",
          slot: "deliveryStatus"
        },
        {
          label: "收货人",
          prop: "receiverName",
          width: "100",
          slot: "receiverName"
        },
        {
          label: "收货地区",
          prop: "receiverRegion",
          width: "250",
          slot: "receiverRegion"
        },
        {
          label: "详细地址",
          prop: "receiverAddress",
          width: "250",
          slot: "receiverAddress"
        },
        {
          label: "收件人手机号",
          prop: "receiverMobile",
          width: "120",
          slot: "receiverMobile"
        },
        {
          label: "快递单号",
          prop: "billCode"
        },
        {
          label: "操作",
          prop: "action",
          width: "220",
          slot: "exchangeAction"
        }
      ],
      // 兑换记录-表单配置
      InputDataThirFormInfo: [
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入用户昵称',
        },
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '兑换时间：',
          dateType: 'datetime',
          defalutLimit: true,
          format: 'yyyy-MM-dd HH:mm:ss',
          lastDay: 30
        },
        {
          type: 'Select',
          prop: 'exchangeStatus',
          label: '兑换状态：',
          placeholder: '请选择',
          options: [
            { label: '全部', value: null },
            { label: '兑换成功', value: 1 },
            { label: '兑换失败', value: 2 },
          ],
        },
      ],
      // 兑换记录(红包)-表单配置
      InputDataThirREDFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入用户昵称',
        },
        {
          type: 'Select',
          prop: 'exchangeStatus',
          label: '兑换状态：',
          placeholder: '请选择',
          options: [
            { label: '全部', value: null },
            { label: '兑换成功', value: 1 },
            { label: '兑换失败', value: 2 },
          ],
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '兑换时间：',
          dateType: 'datetime',
          defalutLimit: true,
          format: 'yyyy-MM-dd HH:mm:ss',
          lastDay: 30,
        },
      ],
      // 开卡记录-表单配置
      InputDataThir2FormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入用户昵称',
        },
        {
          type: 'DateRange',
          startKey: 'openCardTimeStart',
          endKey: 'openCardTimeEnd',
          label: '开卡时间：',
          dateType: 'datetime',
          defalutLimit: true,
          format: 'yyyy-MM-dd HH:mm:ss',
        },
      ],
      // 开发记录-表格配置
      openCardTableColumns: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick"
        },
        {
          label: "首次点击时间",
          prop: "createTime"
        },
        {
          label: "末次点击时间",
          prop: "updateTime"
        },
        {
          label: "开卡时间",
          prop: "openCardTime"
        }
      ],
      inputDataThir2: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入用户PIN",
        },
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入用户昵称：",
        },
        {
          name: "开卡时间：",
          myDate: true,
          val: ["openCardTimeStart", "openCardTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
      ],
      // 预约记录-表单配置
      inputReservationFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入用户昵称：',
        },
        {
          type: 'Select',
          prop: 'isWin',
          label: '中奖状态：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: '全部', value: '' },
            { label: '已中奖', value: 1 },
            { label: '未中奖', value: 0 },
            { label: '待开奖', value: 2 },
          ]
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '预约时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
        }
      ],
      // 预约记录-表格配置
      reservationTableColumns: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick"
        },
        {
          label: "预约时间",
          prop: "joinTime"
        },
        {
          label: "中奖状态",
          prop: "isWin",
          slot: "isWin"
        }
      ],
      // 领取记录-表单配置
      recordFormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入用户PIN',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'prizeType',
          label: '奖品类型：',
          placeholder: '请选择',
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "实物", value: 3 },
            { label: "店铺积分", value: 4 },
            { label: "京东E卡", value: 5 },
            { label: "爱奇艺会员", value: 6 },
            { label: "京东PLUS会员", value: 7 },
            { label: "现金红包", value: 8 },
          ],
        },
        {
          type: 'Select',
          prop: 'status',
          label: '中奖状态：',
          placeholder: '请选择',
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已中奖", value: 2 },
            { label: "已发放", value: 3 },
            { label: "发放失败", value: 4 },
          ],
        },
        {
          type: 'DateRange',
          startKey: 'startTime',
          endKey: 'endTime',
          label: '创建时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: false,
        },
      ],
      // 领取记录-表格配置
      recordTableColumns: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick"
        },
        {
          label: "登记生日",
          prop: "birthDay",
          slot: "birthDay"
        },
        {
          label: "活动名称",
          prop: "activityName"
        },
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeType"
        },
        {
          label: "奖品名称",
          prop: "prizeName",
          slot: "prizeName"
        },
        {
          label: "中奖状态",
          prop: "status",
          slot: "status"
        },
        {
          label: "创建时间",
          prop: "joinTime"
        },
        {
          label: "操作",
          prop: "action",
          width: "200",
          slot: "actionRecord"
        }
      ],
      exchangeList: [],
      totalMail: 0,
      couponList: [],
      formList2: {},

      // 控制录入快递单号弹窗
      enterCoutierNumShow: false,
      // 快递单号
      enterCoutierNum: "",
      // 弹窗表单标识
      enterCoutierFrom: {},
      // 录入快递单号当前行数据存储
      enterCoutierRowData: {},
      // -------打榜有礼数据开始---------
      // 活动统计表头数据
      chongBangTableColumnList: [
        { label: "日期", prop: "statsDate", width: "200" },
        { label: "活动PV", prop: "pv" },
        { label: "活动UV", prop: "uv" },
        { label: "新增入会人数", prop: "openCardNum" },
        { label: "新增关注人数", prop: "followNum" },
        { label: "分享人数", prop: "shareNum" },
        { label: "分享次数", prop: "shareTime" },
        { label: "参与人数", prop: "joinNum" },
        {
          label: "参与人数（有下单）",
          prop: "joinBuyNum",
          width: "210",
        },
        { label: "已付款GMV", prop: "orderAmt" },
        {
          label: "成交订单数（已付款）",
          prop: "orderPayNum",
          width: "210",
        },
        {
          label: "成交商品数（已付款）",
          prop: "orderPayItemNum",
          width: "210",
        },
        {
          label: "成交订单数（已收货）",
          prop: "orderFinishNum",
          width: "210",
        },
        { label: "成交商品数（已收货）", 
          prop: "orderItemNum", 
          width: "210",
        },
        {
          label: "参与成功人数（下单有效金额达到入榜金额）",
          prop: "winNum",
          width: "300",
        },
        { label: "已领奖人数", prop: "receiveNum" },
      ],
      // 折线图颜色数据
      colorList: [
        "#FF0000", "#00FF00", "#0000FF", "#FFFF00", "#FF00FF",
        "#00FFFF", "#FF4500", "#8B4513", "#2E8B57", "#4B0082",
        "#800000", "#008000", "#000080", "#808000", "#800080",
        "#008080", "#DC143C", "#FF8C00", "#00FF7F", "#7B68EE",
        "#8A2BE2", "#A52A2A", "#20B2AA", "#FFD700", "#ADFF2F",
        "#7FFFD4", "#6A5ACD", "#40E0D0", "#FF6347", "#FF69B4",
        "#B0C4DE", "#DAA520", "#48D1CC", "#9370DB", "#2F4F4F",
        "#FFA07A", "#BA55D3", "#7CFC00", "#87CEEB", "#778899"
      ],
      // 小部件管理折线图颜色数组
      colorsList : [
        "#FF5733", "#33FF57", "#5733FF", "#FF33A1", "#A1FF33", "#33A1FF",
        "#FFBB33", "#33FFBB", "#BB33FF", "#FF3366", "#66FF33", "#3366FF",
        "#FF8C33", "#33FF8C", "#8C33FF", "#FF3366", "#66FF33", "#3366FF",
        "#FFB333", "#33FFB3", "#B333FF", "#FF3366", "#66FF33", "#3366FF"
      ],

      // 打榜有礼数据总览数据集合
      dataScreenList: [
        { name: "活动PV", value: "pv" },
        { name: "活动UV", value: "uv" },
        { name: "新增入会人数", value: "openCardNum" },
        { name: "新增关注人数", value: "followNum" },
        { name: "分享人数", value: "shareNum" },
        { name: "分享次数", value: "shareTime" },
        { name: "参与人数", value: "joinNum" },
        { name: "参与人数（有下单）", value: "joinBuyNum" },
        { name: "已付款GMV", value: "orderAmt" },
        { name: "成交订单数（已付款）", value: "orderPayNum" },
        { name: "成交商品数（已付款）", value: "orderPayItemNum" },
        { name: "成交订单数（已收货）", value: "orderFinishNum" },
        { name: "成交商品数（已收货）", value: "orderItemNum" },
        {
          name: "参与成功人数（下单有效金额达到入榜金额）",
          value: "winNum",
        },
        { name: "已领奖人数", value: "receiveNum" },
      ],
      // 派样回购礼数据总览数据集合
      sendReBuydataScreenList: [
        { name: "活动PV", value: "pv" },
        { name: "活动UV", value: "uv" },
        { name: "新增关注人数", value: "followNum" },
        { name: "活动入会人数", value: "openCardNum" },
        { name: "分享人数", value: "shareNum" },
        { name: "分享次数", value: "shareTime" },
        { name: "派样付款金额", value: "sendBuyOrderAmt", tipsName: "派样下单且付款的商品金额（非实付金额）" },
        { name: "派样付款件数", value: "sendBuyItemNum", tipsName: "派样下单且付款的商品件数"},
        { name: "派样付款人数", value: "sendBuyNum", tipsName: "派样下单且付款的人数" },
        { name: "活动入会派样付款人数", value: "openCardSendBuyNum", tipsName: "通过活动入会，派样商品付款的人数"  },
        { name: "活动入会派样付款件数", value: "openCardSendBuyItemNum", tipsName: "通过活动入会，派样商品付款的商品件数"  },
        { name: "活动入会派样付款金额", value: "openCardSendBuyOrderAmt", tipsName: "通过活动入会，派样商品的商品金额（非实付金额）"  },
        { name: "派样收货金额", value: "enterSendBuyOrderAmt", tipsName: "派样商品付款且收货的商品金额（非实付金额）"  },
        { name: "派样收货件数", value: "enterSendBuyItemNum", tipsName: "派样商品付款且收货的商品件数"},
        { name: "派样收货人数", value: "enterSendBuyNum", tipsName: "派样商品付款且收货的人数" },
        { name: "活动入会派样收货人数", value: "openCardEnterSendBuyOrderAmt", tipsName: "通过活动入会且派样商品收货的用户"  },
        { name: "活动入会派样收货件数", value: "openCardEnterSendBuyItemNum", tipsName: "通过活动入会且派样商品收货的商品件数"  },
        { name: "活动入会派样收货金额", value: "openCardEnterSendBuyOrderAmt", tipsName: "通过活动入会且派样商品收货的商品金额（非实付金额）"  },
        { name: "回购付款金额", value: "reBuyOrderAmt", tipsName: "回购商品付款的商品金额（非实付金额）"   },
        { name: "回购付款件数", value: "reBuyItemNum", tipsName: "回购商品付款的件数" },
        { name: "回购付款人数", value: "reBuyNum", tipsName: "回购商品付款的人数"  },
        { name: "活动入会回购付款人数", value: "openCardReBuyNum" , tipsName: "通过活动入会，回购商品付款的人数"},
        { name: "活动入会回购付款件数", value: "openCardReBuyItemNum" , tipsName: "通过活动入会，完成派样付款、回购付款的件数" },
        { name: "活动入会回购付款金额", value: "openCardReBuyOrderAmt" , tipsName: "通过活动入会，回购商品付款的商品金额（非实付金额）" },
        { name: "回购收货金额", value: "enterReBuyOrderAmt" , tipsName: "回购商品付款且收货的商品金额（非实付金额）" },
        { name: "回购收货件数", value: "enterReBuyItemNum", tipsName: "回购商品付款且收货的商品件数" },
        { name: "回购收货人数", value: "enterReBuyNum", tipsName: "回购商品付款且收货的人数" },
        { name: "活动入会回购收货人数", value: "openCardEnterReBuyNum", tipsName: "通过活动入会，回购商品付款且收货的人数" },
        { name: "活动入会回购收货件数", value: "openCardEnterReBuyItemNum", tipsName: "通过活动入会，回购商品付款且收货的商品件数" },
        { name: "活动入会回购收货金额", value: "openCardEnterReBuyOrderAmt", tipsName: "通过活动入会，回购商品付款且收货的商品金额（非实付金额）" },
        { name: "付款回购率", value: "orderReBuyRate", tipsName: "回购付款人数/派样付款人数" },
        { name: "收货回购率", value: "enterReBuyRate", tipsName: "回购收货人数/派样收货人数" },
        { name: "填写收货地址人数", value: "enterNum" },
        { name: "中奖人数", value: "winNum" },
      ],
      // 派样回购礼数据统计表头数据
      sendReBuyTableColumnList: [
        { label: "日期", prop: "statsDate", width: "200" },
        { label: "活动PV", prop: "pv" },
        { label: "活动UV", prop: "uv" },
        { label: "新增店铺关注人数", prop: "followNum" },
        { label: "新增入会人数", prop: "openCardNum" },
        { label: "分享人数", prop: "shareNum" },
        { label: "分享次数", prop: "shareTime" },
        { label: "派样付款金额", prop: "sendBuyOrderAmt" },
        { label: "派样付款件数", prop: "sendBuyItemNum" },
        { label: "派样付款人数", prop: "sendBuyNum" },
        { label: "活动入会派样付款人数", prop: "openCardSendBuyNum", width: "200" },
        { label: "活动入会派样付款件数", prop: "openCardSendBuyItemNum", width: "200" },
        { label: "活动入会派样付款金额", prop: "openCardSendBuyOrderAmt", width: "200" },
        { label: "派样收货金额", prop: "enterSendBuyOrderAmt" },
        { label: "派样收货件数", prop: "enterSendBuyItemNum" },
        { label: "派样收货人数", prop: "enterSendBuyNum" },
        { label: "活动入会派样收货人数", prop: "openCardEnterSendBuyNum", width: "200" },
        { label: "活动入会派样收货件数", prop: "openCardEnterSendBuyItemNum", width: "200" },
        { label: "活动入会派样收货金额", prop: "openCardEnterSendBuyOrderAmt", width: "200" },
        { label: "回购付款金额", prop: "reBuyOrderAmt" },
        { label: "回购付款件数", prop: "reBuyItemNum" },
        { label: "回购付款人数", prop: "reBuyNum" },
        { label: "活动入会回购付款人数", prop: "openCardReBuyNum", width: "200" },
        { label: "活动入会回购付款件数", prop: "openCardReBuyItemNum", width: "200" },
        { label: "活动入会回购付款金额", prop: "openCardReBuyOrderAmt", width: "200"},
        { label: "回购收货金额", prop: "enterReBuyOrderAmt" },
        { label: "回购收货件数", prop: "enterReBuyItemNum" },
        { label: "回购收货人数", prop: "enterReBuyNum" },
        { label: "活动入会回购收货人数", prop: "openCardEnterReBuyNum", width: "200" },
        { label: "活动入会回购收货件数", prop: "openCardEnterReBuyItemNum", width: "200" },
        { label: "活动入会回购收货金额", prop: "openCardEnterReBuyOrderAmt", width: "200" },
        { label: "付款回购率", prop: "orderReBuyRate" },
        { label: "收货回购率", prop: "enterReBuyRate" },
        { label: "填写收货地址人数", prop: "enterNum", width: "200" },
        { label: "中奖人数", prop: "winNum" },
      ],
      // 派样下单记录表头
      sendBuyList: [
        { label: "订单号", prop: "orderId" },
        { label: "付款时间", prop: "orderStartTime" },
        { label: "收货时间", prop: "orderEndTime" },
      ],
      // 回购下单记录表头
      sendReBuyList: [
        { label: "付款时间", prop: "orderStartTime" },
        { label: "收货时间", prop: "orderEndTime" },
      ],

      // 打榜有礼-实物奖品名单-表单配置
      inputInkind2FormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'DateRange',
          startKey: 'sendTimeStart',
          endKey: 'sendTimeEnd',
          label: '发放时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: false,
        },
        {
          type: 'DateRange',
          startKey: 'deliveryTimeStart',
          endKey: 'deliveryTimeEnd',
          label: '发货时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: false,
        },
        {
          type: 'Select',
          prop: 'commitAddressFlag',
          label: '是否提交地址：',
          placeholder: '请选择',
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已提交", value: 1 },
            { label: "未提交", value: 0 },
          ],
        },
        {
          type: 'Select',
          prop: 'prizeStatus',
          label: '中奖状态：',
          placeholder: '请选择',
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "未中奖", value: 1 },
            { label: "已中奖", value: 2 },
            { label: "待发放", value: 7 },
            { label: "已发放", value: 3 },
            { label: "发放失败", value: 4 },
          ],
        },
      ],
      inputInkind3FormInfo: [
        {
          type: 'Input',
          prop: 'pin',
          label: '用户PIN：',
          placeholder: '请输入',
        },
        {
          type: 'Input',
          prop: 'memberNick',
          label: '用户昵称：',
          placeholder: '请输入',
        },
        {
          type: 'Select',
          prop: 'status',
          label: '发货状态：',
          placeholder: '请选择',
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已发货", value: "5" },
            { label: "未发货", value: "2,7" },
          ],
        },
        {
          type: 'DateRange',
          startKey: 'sendTimeStart',
          endKey: 'sendTimeEnd',
          label: '发放时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: false,
        },
        {
          type: 'DateRange',
          startKey: 'deliveryTimeStart',
          endKey: 'deliveryTimeEnd',
          label: '发货时间：',
          dateType: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          defalutLimit: false,
        },
        {
          type: 'Select',
          prop: 'commitAddressFlag',
          label: '是否提交地址：',
          placeholder: '请选择',
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已提交", value: 1 },
            { label: "未提交", value: 0 },
          ],
        },
      ],
      // 领奖记录表头数据
      chongBangAwardList: [
        // { label: "用户PIN", prop: "pin", width: "200" },
        { label: "用户昵称", prop: "memberNick", width: "170" },
        { label: "活动名称", prop: "activityName" },
        { label: "总订单金额（已付款）", prop: "totalPayMoney", width: "180" },
        { label: "总订单笔数（已付款）", prop: "orderPayNum", width: "180" },
        { label: "总订单金额（已收货）", prop: "totalFinishMoney", width: "180" },
        { label: "总订单笔数（已收货）", prop: "orderFinishNum", width: "180" },
        { label: "名次", prop: "rank" },
        { label: "奖品类型", prop: "prizeTypeStr" },
        { label: "奖品名称", prop: "prizeName" },
        { label: "订单号", prop: "orderIdStr" },
        { label: "中奖状态", prop: "statusStr" },
        { label: "参与时间", prop: "joinTime", width: "200" },
        { label: "领奖时间", prop: "winTime", width: "200" },
        { label: "发放时间", prop: "grantTime", width: "200" },
      ],
      // 实物奖品名单 - 打榜有礼
      chongBangPhysicalList: [
        { label: "发放时间", prop: "sendTime", width: "200" },
        { label: "中奖状态", prop: "prizeStatus" },
        { label: "发货状态", prop: "deliveryStatusStr" },
        { label: "快递单号", prop: "billCode" },
        { label: "发货时间", prop: "deliveryTime", width: "200" },
      ],
      // 生日有礼-实物奖品名单
      chongBangPhysicalList2: [
        { label: "发放时间", prop: "sendTime", width: "200" },
        { label: "发货状态", prop: "statusStr" },
        { label: "快递单号", prop: "billCode" },
        { label: "发货时间", prop: "grantTime", width: "200" },
      ],
      // 批量发货弹窗
      fileList: [],
      // 批量发放请求头设置
      physicalBatchShipmentHeaderOdj: {},
      physicalBatchShipmentShow: false,
      physicalBatchShipmentFrom: {},
      // 发货弹窗
      sendOutGoodsShow: false,
      // 导入结果集合
      downloadResData: {
        successNum: 0,
        failNum: 0,
      },
      // 导入失败用户列表
      downloadUserList: [],
      sendOutGoodsForm: {
        id: "",
        billCode: "",
        isUpdatePrizeStatus: true,
      },
      // -----------打榜有礼数据结束-------------
      tabName: '',
      actTab: "",
      batchMarkVisible:false,
      myFormInfo: [
        {
          label: "统计时间：",
          slot: "evaluateTime",
        },
      ],
      defaultIndex: 0, // 默认选中第一个时间
    };
  },
  filters: {
    typeChinese(val) {
      let arr = [
        "全部",
        "平台新用户",
        "品类新用户",
        "店铺新用户",
        "店铺近180天未下单客户",
        "店铺已购客户",
        "未入户用户",
        "开卡会员",
      ];
      if (val.memberRole == 1) {
        return "-";
      }
      const tempList = val.memberType.split(",");
      let str = "";
      tempList.map((item) => {
        str = str + "," + arr[Number(item)];
      });
      str = str.slice(1, str.length);
      return str;
    },
  },
  computed: {
    loginUserInfo() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo;
    },
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    // 生成人群参数
    crowCondition() {
      if (this.rowData.activityType == 39) {
        return this.formListRecord
      } else if (this.rowData.activityType == 45) {
        return this.formListLock
      } else {
        return this.formList
      }
    },
    userInfoTableColumns() {
      const baseColumns = [...this.userInfoBaseColumns];

      // 根据RuleFieldsList过滤动态列
      const dynamicColumns = this.userInfoDynamicColumns.filter(column => {
        return this.RuleFieldsList.includes(column.fieldName);
      });

      return [...baseColumns, ...dynamicColumns];
    },
    // 优惠券统计-表格配置
    couponStatisticsTableColumns() {
      const baseColumns = [];

      // 根据活动类型添加不同的列
      if (this.fitersChooseIF([21])) {
        baseColumns.push(
          {
            label: "日期",
            prop: "name"
          },
          {
            label: "发放量",
            prop: "grantNum"
          }
        );
      }

      if (this.fitersChooseIF([31])) {
        baseColumns.push(
          {
            label: "日期",
            prop: "date"
          }
        );

        if (this.couponList && this.couponList.length > 0) {
          this.couponList.forEach(item => {
            baseColumns.push({
              label: item.name,
              prop: item.value
            });
          });
        }
      }

      return baseColumns;
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
  },
  async created() {
    console.log("rowData", this.rowData);
    console.log("ids", this.ids1);
    if(this.rowData.activityType == 25 || this.rowData.activityType == 32 || this.rowData.activityType == 33 || this.rowData.activityType == 26|| this.rowData.activityType == 56|| this.rowData.activityType == 57){
      this.dataSummary = [
        {
          value: "onlineUv",
          name: "访客数",
          tips: false, // 提示的显示隐藏
        },
        {
          value: "avgRead",
          name: "人均浏览量",
          tips: false,
        },
        {
          value: "cartRate",
          name: "访客加购率",
          tips: false,
        },
        {
          value: "clickUv",
          name: "点击用户数",
          tips: false,
        },
        {
          value: "clickPv",
          name: "点击次数",
          tips: false,
        },
        {
          value: "ordUsrNum",
          name: "下单用户数",
          tips: false,
        },
        {
          value: "payOrderNum",
          name: "成交订单量",
          tips: false,
        },
        {
          value: "orderNum",
          name: "引入订单量",
          tips: false,
        },
        {
          value: "orderRate",
          name: "点击用户下单转化率",
          tips: false,
        },
        {
          value: "cartNum",
          name: "加购商品数",
          tips: false,
        },
        {
          value: "uvValue",
          name: "UV价值",
          tips: false,
        },
        {
          value: "payOrdLineNum",
          name: "引入订单行",
          tips: false,
        },
        {
          value: "onlinePv",
          name: "浏览量",
          tips: false,
        },
        {
          value: "sumPayOrdAmount",
          name: "成交金额",
          tips: false,
        },
        {
          value: "avgOrderAmount",
          name: "客单价",
          tips: false,
        },
        {
          value: "payOrdUsrNum",
          name: "成交用户数",
          tips: false,
        },
        {
          value: "clickRate",
          name: "点击率",
          tips: false,
        },
        {
          value: "payOrderRate",
          name: "下单-支付转化率",
          tips: false,
        },
        {
          value: "visitUsrPayOrderRate",
          name: "访客成交转化率",
          tips: false,
        },
        {
          value: "payOrdLine",
          name: "成交订单行",
          tips: false,
        },
      ];
      this.dataSummary.forEach((item, index) => {
        item.color = this.colorList[index];
      })
    }
    // 打榜有礼
    if (this.rowData.activityType == 36) {
      let arr = this.dataScreenList;
      arr.forEach((item, index) => {
        item.color = this.colorList[index];
        item.tips = false;
      });
      this.dataSummary = arr;
    }
    // 派样回购礼
    if (this.rowData.activityType == 37) {
      let arr = this.sendReBuydataScreenList;
      arr.forEach((item, index) => {
        item.color = this.colorList[index];
        // item.tips = false;
      });
      this.dataSummary = arr;
    }
    if (this.rowData.activityType == 35) {
      // this.activeName = "eighteen"
      // this.handleClick({name: "eighteen",})
      this.dataSummary = [
        {
          value: "pv", // 对应tableTotal的字段
          name: "活动PV",
          tips: false, // 提示的显示隐藏
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "uv",
          name: "活动UV",
          tips: false,
          color: "#B2A8DA",
        },
        {
          value: "lockNum",
          name: "参与锁权人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "openCardNum",
          name: "活动入会人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "shareUv",
          name: "分享人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "sharePv",
          name: "分享次数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockBuyNum",
          name: "锁权用户购买人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockBuyOrderAmt",
          name: "锁权用户购买金额",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockBuyOrderNum",
          name: "锁权用户购买订单数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockPassBuyOrderAmt",
          name: "锁权且满足活动门槛用户的购买金额",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockPassBuyOrderNum",
          name: "锁权且满足活动门槛用户的购买订单数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "openCardBuyOrderAmt",
          name: "活动入会用户下单金额",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "openCardBuyNum",
          name: "活动入会用户下单人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "passNum",
          name: "订单满足活动中奖门槛人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "winNum",
          name: "中奖人数",
          tips: false,
          color: "#F2D0B5",
        },
      ];
      this.dataSummary1 = [
        {
          value: "pv", // 对应tableTotal的字段
          name: "活动PV",
          tips: false, // 提示的显示隐藏
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "uv",
          name: "活动UV",
          tips: false,
          color: "#B2A8DA",
        },
        {
          value: "lockNum",
          name: "参与锁权人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "openCardNum",
          name: "活动入会人数",
          tips: false,
          color: "#F2D0B5",
        },
        // {
        //   value: "shareUv",
        //   name: "分享人数",
        //   tips: false,
        //   color: "#F2D0B5",
        // },
        // {
        //   value: "sharePv",
        //   name: "分享次数",
        //   tips: false,
        //   color: "#F2D0B5",
        // },
        {
          value: "lockBuyNum",
          name: "锁权用户购买人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockBuyOrderAmt",
          name: "锁权用户购买金额",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockBuyOrderNum",
          name: "锁权用户购买订单数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockPassBuyOrderAmt",
          name: "锁权且满足活动门槛用户的购买金额",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "lockPassBuyOrderNum",
          name: "锁权且满足活动门槛用户的购买订单数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "openCardBuyOrderAmt",
          name: "活动入会用户下单金额",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "openCardBuyNum",
          name: "活动入会用户下单人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "passNum",
          name: "订单满足活动中奖门槛人数",
          tips: false,
          color: "#F2D0B5",
        },
        {
          value: "winNum",
          name: "中奖人数",
          tips: false,
          color: "#F2D0B5",
        },
      ];
      setTimeout(() => {
        this.timeChange();
        this.queryTotal();
        this.getShopGiftParticipateConver();
        // 过滤dateTime为null的数据
        this.filterChartData();
        this.initChart(); //折线图
      }, 1000);
    } else {
      this.timeChange();
      await this.queryTotal();
      // 过滤dateTime为null的数据
      this.filterChartData();
      await this.initChart(); //折线图
      //下单转化数据
      this.getShopGiftParticipateConver();
      if (this.rowData.activityType == 24) this.inputParticipat.splice(2, 1);
      if (this.fitersChooseIF([16, 17, 18, 19, 27, 28])) {
        this.inputInkind.push(
          {
            name: "关联订单状态:",
            val: "orderState",
            placeholder: "请选择",
            selectArr: [
              { label: "全部", id: null },
              { label: "等待付款", id: "等待付款" },
              { label: "暂停", id: "暂停" },
              { label: "等待出库", id: "等待出库" },
              { label: "等待发货", id: "等待发货" },
              { label: "完成", id: "完成" },
              { label: "取消", id: "取消" },
              { label: "锁定", id: "锁定" },
              { label: "等待确认收货", id: "等待确认收货" },
              { label: "未知", id: "未知" },
            ],
          },
          {
            name: "订单号:",
            val: "orderId",
            placeholder: "请输入",
          }
        );
      }
      if (this.fitersChooseIF([31])) {
        this.InputCouponFormInfo.splice(0, 1);
        this.InputGroupCouponFormInfo.push({
          type: 'Select',
          prop: 'status',
          label: '拼券状态：',
          placeholder: '请选择',
          value: '',
          options: [
            { label: "全部", value: '' },
            { label: "拼券中", value: 1 },
            { label: "拼券失败", value: 3 },
            { label: "拼券成功", value: 2 },
          ],
        });
        const { data: res } = await getCoupon(this.rowData.id);
        this.couponList = res;
      }
      if (this.fitersChooseIF([32])) {
        this.InputCouponFormInfo.splice(0, 1);
        this.getopenCardRecord();
        // 初始化入会用户转化分析数据
        this.resetConversionFun();
      }
    // if (this.fitersChooseIF([56])) {
    //     this.getopenCardRecord()
    //  }
    //     if (this.fitersChooseIF([57])) {
    //     this.getopenCardRecord()
    //  }
      if (this.fitersChooseIF([33])) {
        this.getappointment();
      }
    }
  },
  methods: {
      // 过滤chart数据，移除dateTime为null的项
      filterChartData() {
        // 确保chartEffectDetail存在且是数组
        if (Array.isArray(this.chartEffectDetail)) {
          // 过滤掉dateTime为null的数据
          this.filteredChartEffectDetail = this.chartEffectDetail.filter(item => item.dateTime !== null);
        } else {
          this.filteredChartEffectDetail = [];
        }
      },
      searchConversionFun(data) {
        this.conversionPage.size = 10;
        this.conversionPage.current = 1;
        this.searchConversion(data);
      },
    // 入会分析
    searchConversion(val) {
      // 重置
      this.loading = true;
      const { size, current } = this.conversionPage;
      const query = {
        size,
        current,
        activityId: this.rowData.id,
        statType: this.conversionForm.statType,
        compareType: this.conversionForm.compareType,
        source:  1
      };
      if (this.conversionForm.statDaysNum) {
        query.statDaysNum = this.conversionForm.statDaysNum;
      }
      if (this.conversionForm.orderAmount) {
        query.orderAmount = this.conversionForm.orderAmount;
      }
      if (val && val.openCardStartTime) {
        query.openCardStartTime = val.openCardStartTime;
      }
      if (val && val.openCardEndTime) {
        query.openCardEndTime = val.openCardEndTime;
      }
      // if(val && query.sellerLinkId!=null){
        query.sellerLinkId = val.sellerLinkId;
      // }
      this.memberAnalysisSearchQuery = query;
      memConvAnalysis(query)
        .then((res) => {
          this.loading = false;
          this.conversionData = res.data.records;
          this.conversionPage.total = Number(res.data.total);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    resetConversionFun() {
      this.conversionForm.statDaysNum = 30;
      this.conversionForm.statType = 0;
      this.conversionForm.compareType = 0;
      this.conversionForm.orderAmount = null;
      this.conversionPage.size = 10;
      this.conversionPage.current = 1;
      this.$refs.export_funRef.reData();
      this.searchConversion({
        openCardStartTime: this.getDateStr(-30) + " 00:00:00",
        openCardEndTime: this.getDateStr(0) + " 23:59:59"
      });
    },
    handlePageConversion(pageInfo) {
      this.conversionPage.size = pageInfo.pageSize;
      this.conversionPage.current = pageInfo.pageNum;
      this.searchConversion(this.memberAnalysisSearchQuery);
    },
    closeBigImg() {
      this.dialogImageUrl = "";
    },
    // 放大图片
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
    },
    showextendInfo(obj) {
      let obj1 = obj ? JSON.parse(obj) : {};
        let arr = []
        for (const key in obj1) {
          if (obj1.hasOwnProperty(key)) {
            let keys = key;
            let isImg = false
            let val = ""
            if(this.isLink(obj1[key]).flag) {
              isImg = true
            }
            console.log(this.isLink(obj1[key]),'4444');
            val = this.isLink(obj1[key]).newVal;
            arr.push({prop: keys,keys:val,isImg})
          }
        }
        return arr;
    },
    isLink(val) {
      let newVal = ""
      let flag = false
      let reg = new RegExp(/^http|https?:\/\//)
      if(val.indexOf("[")!=-1) {
        flag = reg.test(val)
        newVal = JSON.parse(val)
      }else {
        newVal = val
      }
      return {flag,newVal}
    },
    addCrowd(val) {
      // 如果版本为京获客旗舰版需要校验用户时候有该按钮权限
      if (this.softType == 1 && !this.$store.getters.isJhkPlatformSeller) {
        return this.$message.warning("您不满足使用该功能，请联系专属客服了解~")
      }
      if(val == 26){
        this.hasDefaultValue = true
        this.defaultValueText = '参与记录'
      }
      this.source = val;
      this.isShowCrowdDialog = true;
      // 用户分析默认值
      if (val == 18) {
        this.hasDefaultValue = true;
        this.defaultValueText = "入会用户转化分析";
      } else if (
        [26].includes(val) ||
        ([29].includes(val) && this.activeName == "openWinRecord")
      ) {
        this.hasDefaultValue = true;
        this.defaultValueText = "参与记录";
      }else if(val == 37){
        this.hasDefaultValue = true;
        this.defaultValueText = "参与记录";
      } else if (val == 30) {
        this.hasDefaultValue = true;
        this.defaultValueText = "幸运值获取记录";
      } else if (val == 34) {
        this.hasDefaultValue = true;
        if (this.tabName == "zeroTrial") {
          this.defaultValueText = "参与记录";
        }
      }
      // 晒单有礼-默认值
      if (this.rowData.activityType == 41) {
        this.hasDefaultValue = true;
        let txtMap = {
          20: "用户资料",
          3: "中奖记录",
          4: "实物奖品名单",
        };
        this.defaultValueText = txtMap[val];
      } else if (this.rowData.activityType == 45 && val == 3) {
        this.hasDefaultValue = true;
        this.defaultValueText = "领奖记录";
      }
      // 试用反馈详情
      if (this.tabName == "trialDetail") {
        this.hasDefaultValue = true;
        this.defaultValueText = "试用反馈详情";
      }
    },
    crowdClose(){
      this.isShowCrowdDialog = false
      // 关闭时重置
      if(this.hasDefaultValue){
        this.hasDefaultValue = false
        this.defaultValueText = ''
      }
    },
    // 实物奖品名单导出
    goodsExportDialog(){
      if(this.rowData.activityType == 39){
        this.control2 = true
      }else{
        this.control3 = true
      }
    },
    // 导出数据
    async exportFn() {
      this.control1 = true;
    },
    getphone1(val){  
      this.exportTheData(val)
    }, 
    getphone2(val){  
      this.getApi_Exprot(val)
    }, 
    getphone3(val){
      this.getApi_Exprot2(this.tabName == 'twenty-one' ? 2 : this.tabName == 'twenty' ? 3 :  1, val)
    }, 
    getphone4(val){
      this.savePhone(val)
    },

    editAddress(row) {
      this.takeGoodsForm.id = row.id;
      this.$decryptBatch
        .decrypt([
          row.decryptMemberNick,
          row.decryptMobile,
          row.decryptReceiverAddress,
          row.decryptDetailedAddress,
        ])
        .then((res) => {
          if (res.code == 1) {
            let data = res.data;
            this.takeGoodsForm.receiverName = data[0];
            this.takeGoodsForm.receiverMobile = data[1];
            this.takeGoodsForm.receiverAddress = data[2];
            this.takeGoodsForm.detailedAddress = data[3];
            this.lockTakeGoodsVisible = true;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    setTakeGoods() {
      if (!this.takeGoodsForm.receiverName) {
        return this.$message.info("请输入姓名");
      } else if (!this.takeGoodsForm.receiverMobile) {
        return this.$message.info("请输入手机号码");
      } else if (!this.takeGoodsForm.receiverAddress) {
        return this.$message.info("请输入地区");
      } else if (!this.takeGoodsForm.detailedAddress) {
        return this.$message.info("请输入详细地址");
      }
      updateReceiveAddress({ ...this.takeGoodsForm }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.$message.success("修改成功");
          this.lockTakeGoodsVisible = false;
          this.takeGoodsRecord();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 单个发货
    sendGoods(row) {
      let billCode = row.billCode || null;
      this.$prompt("快递单号：", "发货信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "lock_message_box",
        inputValue: billCode,
        inputValidator: (value) => {
          if (!value) {
            this.$message({
              type: "info",
              message: "请输入快递单号",
            });
            return "";
          }
        },
      })
        .then(({ value }) => {
          if (!value) {
            this.$message({
              type: "info",
              message: "请输入快递单号",
            });
            return false;
          } else {
            lockSendStatus({ id: row.id, billCode: value }).then((res) => {
              if (res.code == 1) {
                // 刷新列表
                this.winningRecord();
              } else {
                this.$message({
                  type: "info",
                  message: res.message,
                });
              }
            });
          }
        })
        .catch(() => {});
    },
    // 确权 中奖记录批量发货
    batchLock() {
      this.batchLockVisible = true;
    },
    // 确权 中奖记录批量发货
    batchLockClose() {
      this.winningRecord();
      this.batchLockVisible = false;
    },
    // 跳转至商品详情页
    jumpTo() {},
    //Note----邀请明细
    // invitationDeatils(val){
    //   this.dialogDeatils = true;
    // },
    handleReservationPage(page) {
      this.formList.size = page.pageSize;
      this.formList.current = page.pageNum;
      if (this.rowData.activityType == 32) {
        this.getopenCardRecord();
      } else if (this.rowData.activityType == 33) {
        this.getappointment();
      }
    },
    searchFormThir2(val) {
      this.formList2 = val;
      if (this.rowData.activityType == 32) {
        this.getopenCardRecord();
      } else if (this.rowData.activityType == 33) {
        this.getappointment();
      }
    },
    handlePageOpenCard(page){
      this.formList.current = page.pageNum;
      this.formList.size = page.pageSize;
      this.getopenCardRecord();
    },
    getopenCardRecord() {
      this.loading = true;
      var obj = {
        ...this.formList,
        id: this.rowData.id,
        memberNick: this.formList2.memberNick,
        createTimeStart: this.formList2.createTimeStart,
        createTimeEnd: this.formList2.createTimeEnd,
        openCardTimeStart: this.formList2.openCardTimeStart,
        openCardTimeEnd: this.formList2.openCardTimeEnd,
      };
      openCardRecord(obj).then((res) => {
        this.loading = false;
        this.exchangeList = res.data.records;
        this.totalMail = Number(res.data.total);
      });
    },
    getappointment() {
      this.loading = true;
      var obj = {
        ...this.formList,
        memberNick: this.formList2.memberNick,
        isWin: this.formList2.isWin,
        startTime: this.formList2.startTime,
        endTime: this.formList2.endTime,
      };
      appointment(obj).then((res) => {
        this.loading = false;
        this.exchangeList = res.data.records;
        this.totalMail = Number(res.data.total);
      });
    },
    // 监听录入快递单号按钮
    handleEnterCoutierNum(row) {
      this.enterCoutierNum = row.billCode;
      this.enterCoutierRowData = row;
      this.$forceUpdate();
      // 打开弹窗
      this.enterCoutierNumShow = true;
    },
    // 输入框限制输入数字
    // enterCoutierInputLimit(value) {
    //   // console.log("input", value);
    //   this.enterCoutierNum = Number(value.replace(/[^\d]/g, ""));
    // },
    clearInput (e) {
      let key = e.key;
      if (key === 'e' || key === 'E' || key === '+' || key === '-') {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    // 置空录入快递单号输入框并关闭弹窗
    blankEnterCoutierNum() {
      this.enterCoutierNum = "";
      // 清除当前行存储数据
      this.enterCoutierRowData = {};
      this.enterCoutierNumShow = false;
      this.sendOutGoodsShow = false;
    },
    // 录入快递单号提交
    enterCoutierSubmit() {
      let params = {
        billCode: this.enterCoutierNum,
        // 这里默认传true
        isUpdatePrizeStatus: true,
      }
      // console.log("enterCoutierRowData", this.enterCoutierRowData);
      // console.log("录入快递单信息参数", params);
      let fn = markingSendStatusLockRight
      if(this.rowData.activityType == 9){
        fn = markingSendStatus
        params.recordId = this.enterCoutierRowData.id
      }else{
        params.id = this.enterCoutierRowData.id
      }
      fn(params).then((res) => {
        console.log("markingSendStatusLockRight", res);
        if(res.code == 1){
          if(this.rowData.activityType == 9){
            this.$message.success("录入快递单号成功");
            this.getList()
          }else{
            this.inKingRecord();
          }
          // 标记发货
          // this.markIss(this.enterCoutierRowData).then(()=>{
            // 置空录入快递单号输入框
            this.blankEnterCoutierNum();
          // });
        }else {
          this.$message.error(res.message);
        }
      }).catch(() => {
        this.$message.error("录入快递单号失败");
      })
      
      
    },
    // 打榜有礼领奖记录标记发放
    chongBangAwardMark(row) {
      this.markIss(row);
    },
    // 打榜有礼发货弹框回调
    // 录入快递单号提交
    goodsEnterCoutierSubmit() {
      let params = {
        id: this.enterCoutierRowData.id,
        billCode: this.enterCoutierNum,
        // 这里默认传true
        isUpdatePrizeStatus: true,
      }
      // console.log("enterCoutierRowData", this.enterCoutierRowData);
      // console.log("录入快递单信息参数", params);
      markingSendStatusLockRight(params).then((res) => {
        console.log("markingSendStatusLockRight", res);
        if(res.code == 1){
          // 标记发货
          // this.markIss(this.enterCoutierRowData).then(()=>{
            // 置空录入快递单号输入框
            this.blankEnterCoutierNum();
            // 刷新列表
            this.getGoodsRecord();
          // });
        }else {
          this.$message.error(res.message);
        }
      }).catch(() => {
        this.$message.error("录入快递单号失败");
      })
    },

    // 打榜有礼实物标记发货
    chongBangPhysicalMark(row) {
      // 回显数据
      this.enterCoutierNum = row.billCode;
      this.enterCoutierRowData = row;
      this.sendOutGoodsShow = true;
    },
    // 打榜有礼批量发货
    physicalBatchShipment() {
      // console.log("1111");
      this.physicalBatchShipmentShow = true;
    },
    physicalBatchShipmentClose() {
      this.physicalBatchShipmentShow = false;
      this.downloadResData = {};
      this.downloadUserList = [];
      this.handleClick(this.actTab);
      // TODO: 清空上传信息
      // this.downloadResData = {};
      // this.downloadUserList  = [];
    },
    // 打榜有礼批量发货弹框确认按钮
    physicalBatchShipmentSubmit() {
      // TODO: 清空上传列表，刷新表格
      // this.fileList = [];
      this.downloadResData = {};
      this.downloadUserList = [];
      // this.searchInkind();
    },
    // 上传文件回调
    handleUpload(res) {
      console.log("res", res);
      // 上传文件
      if(res.code == 0){
        this.$message.error(res.message);
      }else if(res.code == 1){
        this.downloadResData = res.data;
        this.downloadUserList = res.data.failUserName;
      }
    },
    // 上传文件处理
    beforeUploadFile(file) {
      this.loading = true;
    },
    chongBangExport() {
      this.chongBangExportDialogShow = true;
      // export_get
    },
    // 下载模板
    handleDownloadTemplate() {
      let url = "";
      if(this.fitersChooseIF([36])){
        url = "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF.xlsx";
      }else {
        url = "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF2.xlsx";
      }
      let fileName= "实物奖品名单批量发货模板.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    // 切换版本
    triggerVersion(){
      this.$emit("triggerVersion",true)
    },
    // 返回数据统计表格配置
    initTableColumns() {
      let activityTableColumns = [];

      // 根据活动类型动态配置列
      if (this.fitersChooseIF([35, 36, 37],"!=")) {
        activityTableColumns.push(
          { prop: 'dateTime', label: '参与时间', slot: 'dateTime' }
        );

        activityTableColumns.push({
          label: '活动参与统计',
          width: '500',
          slot: 'participateStats'
        });
      }

      if (this.fitersChooseIF([25, 32, 33, 35, 36, 37,56,57],"!=")) {
        activityTableColumns.push({
          prop: 'prizeNum',
          label: '奖品统计',
          slot: 'prizeStats'
        });
      }
      // 活动类型35的列配置
      if (this.fitersChooseIF([35])) {
        const type35Columns = [
          { prop: 'statsDate', label: '日期', width: '200' },
          { prop: 'pv', label: '访问次数', width: '200' },
          { prop: 'uv', label: '访问人数', width: '200' },
          { prop: 'openCardNum', label: '活动入会人数', width: '200' },
          { prop: 'lockNum', label: '参与锁权人数', width: '200' },
          { prop: 'passNum', label: '订单满足活动中奖门槛人数', width: '200' },
          { prop: 'winNum', label: '中奖人数', width: '200' },
          { prop: 'enterNum', label: '填写收货地址人数', width: '200' },
          { prop: 'lockBuyNum', label: '锁权用户购买人数', width: '200' },
          { prop: 'lockBuyOrderNum', label: '锁权用户购买订单数', width: '200' },
          { prop: 'lockBuyOrderAmt', label: '锁权用户购买金额', width: '200' },
          { prop: 'lockPassBuyOrderNum', label: '锁权且满足活动门槛用户的购买订单数', width: '300' },
          { prop: 'lockPassBuyOrderAmt', label: '锁权且满足活动门槛用户的购买金额', width: '300' },
          { prop: 'openCardBuyNum', label: '活动入会用户下单人数', width: '200' },
          { prop: 'openCardBuyOrderAmt', label: '活动入会用户下单金额', width: '200' }
        ];
        activityTableColumns = type35Columns;
      }

      // 打榜有礼（活动类型36）
      if (this.fitersChooseIF([36])) {
        activityTableColumns = this.chongBangTableColumnList.map(item => ({
          prop: item.prop,
          label: item.label,
          width: item.width || '120'
        }));
      }

      // 派样回购礼（活动类型37）
      if (this.fitersChooseIF([37])) {
        activityTableColumns = this.sendReBuyTableColumnList.map(item => ({
          prop: item.prop,
          label: item.label,
          width: item.width || '120'
        }));
      }
      return activityTableColumns;
    },
    // 参与记录-表格配置
    initParticipatTableColumns() {
      if(this.fitersChooseIF([23])){
        return this.participatTableColumns1;
      }else {
        return this.participatTableColumns2;
      }
    },
    // 中奖记录-表单配置
    initInputAwardFormInfo() {
      if (this.rowData.activityType != 5) {
        let formInfo = [
          {
            type: 'Input',
            prop: 'pin',
            label: '用户PIN：',
            placeholder: '请输入',
          },
          {
            type: 'Input',
            prop: 'memberNick',
            label: '用户昵称：',
            placeholder: '请输入',
          },
          {
            type: 'Select',
            prop: 'status',
            label: this.fitersRepurchase([16, 17, 18, 27], '发放状态：', '中奖状态：'),
            placeholder: '请选择',
            options: [
              {
                label: this.fitersRepurchase([16, 17, 18, 27], '待领取', '未中奖'),
                value: this.fitersRepurchase([16, 17, 18, 27], -1, 1)
              },
              {
                label: this.fitersRepurchase([16, 17, 18, 27], '待发放', '已中奖'),
                value: 2
              },
              { label: '已发放', value: 3 },
              { label: '发放失败', value: 4 },
            ]
          },
          {
            type: 'Select',
            prop: 'prizeType',
            label: '奖品类型：',
            placeholder: '请选择',
            options: [
              { label: '优惠券', value: 1 },
              { label: '京豆', value: 2 },
              { label: '实物', value: 3 },
              { label: '店铺积分', value: 4 },
              { label: '京东E卡', value: 5 },
              { label: '爱奇艺会员', value: 6 },
              { label: 'PLUS会员', value: 7 },
              { label: '现金红包', value: 8 },
            ]
          },
          {
            type: 'DateRange',
            startKey: 'startTime',
            endKey: 'endTime',
            label: this.fitersRepurchase([16, 17, 18, 27], '领奖时间：', '参与时间：'),
            dateType: 'datetime',
            defalutLimit: true,
            format: 'yyyy-MM-dd HH:mm:ss',
          }
        ];
        if (this.fitersChooseIF([16, 17, 18, 19, 27, 28])) {
          // 添加已失效状态
          formInfo[2].options.push({ label: '已失效', value: 8 });
          // 添加关联订单状态
          formInfo.push({
            type: 'Select',
            prop: 'orderState',
            label: '关联订单状态：',
            placeholder: '请选择',
            options: [
              { label: '等待付款', value: '等待付款' },
              { label: '暂停', value: '暂停' },
              { label: '等待出库', value: '等待出库' },
              { label: '等待发货', value: '等待发货' },
              { label: '完成', value: '完成' },
              { label: '取消', value: '取消' },
              { label: '锁定', value: '锁定' },
              { label: '等待确认收货', value: '等待确认收货' },
              { label: '未知', value: '未知' },
            ]
          });
          // 添加订单号
          formInfo.push({
            type: 'Input',
            prop: 'unlockOrderId',
            label: '订单号：',
            placeholder: '请输入',
          });
          // 下单抽奖添加白名单
          if (this.fitersChooseIF([19])) {
            formInfo.push({
              type: 'Select',
              prop: 'isWhite',
              label: '是否白名单：',
              placeholder: '请选择',
              value: '',
              options: [
                { label: '不限', value: '' },
                { label: '是', value: 1 },
                { label: '否', value: 0 },
              ]
            });
          }
        }
        return formInfo;
      } else {
        return [
          {
            type: 'Input',
            prop: 'pin',
            label: '用户PIN：',
            placeholder: '请输入',
          },
          {
            type: 'Input',
            prop: 'memberNick',
            label: '用户昵称：',
            placeholder: '请输入',
          },
          {
            type: 'Select',
            prop: 'status',
            label: this.fitersRepurchase([16, 17, 18, 27], '发放状态：', '中奖状态：'),
            placeholder: '请选择',
            options: [
              {
                label: this.fitersRepurchase([16, 17, 18, 27], '待领取', '未中奖'),
                value: this.fitersRepurchase([16, 17, 18, 27], -1, 1)
              },
              {
                label: this.fitersRepurchase([16, 17, 18, 27], '待发放', '已中奖'),
                value: 2
              },
              { label: '已发放', value: 3 },
              { label: '发放失败', value: 4 },
            ]
          },
          {
            type: 'Select',
            prop: 'prizeType',
            label: '奖品类型：',
            placeholder: '请选择',
            options: [
              { label: '优惠券', value: 1 },
              { label: '京豆', value: 2 },
              { label: '实物', value: 3 },
              { label: '店铺积分', value: 4 },
              { label: '京东E卡', value: 5 },
              { label: '爱奇艺会员', value: 6 },
              { label: 'PLUS会员', value: 7 },
              { label: '现金红包', value: 8 },
            ]
          },
          {
            type: 'DateRange',
            startKey: 'startTime',
            endKey: 'endTime',
            label: '中奖时间：',
            dateType: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
          }
        ];
      }
    },
    // 中奖记录-表格配置
    getAwardTableColumns() {
      const columns = [];
      const activityType = this.rowData.activityType;

      // 选择列
      columns.push({
        type: "selection",
        width: "55"
      });

      // 用户pin
      columns.push({
        label: "用户pin（加密）",
        prop: "chaosPin",
        width: "150"
      });

      // 用户昵称
      columns.push({
        label: "用户昵称",
        prop: "memberNick",
        width: "210"
      });

      // 活动名称 - 排除活动类型5和6
      if (activityType != 6 && activityType != 5) {
        columns.push({
          label: "活动名称",
          prop: "activityName"
        });
      }

      // 奖品类型
      columns.push({
        label: "奖品类型",
        prop: "prizeType",
        slot: "prizeType"
      });

      // 奖品名称
      columns.push({
        label: "奖品名称",
        prop: "prizeName",
        width: "210"
      });

      // 订单号 - 仅特定活动类型显示
      if (this.fitersChooseIF([16, 17, 18, 19, 27, 28])) {
        columns.push({
          label: "订单号",
          prop: "orderId",
          width: "210",
          slot: "orderId",
          slotHead: 'orderHeader'
        });
      }

      // 是否白名单 - 仅活动类型19显示
      if (this.fitersChooseIF([19])) {
        columns.push({
          label: "是否白名单",
          prop: "isWhite",
          width: "100",
          slot: "isWhite"
        });
      }

      // 时间相关列
      if (activityType != 5 && activityType != 6) {
        columns.push({
          label: this.fitersRepurchase([16, 17, 18, 27], '领奖时间', '参与时间'),
          prop: "joinTime",
          width: "210",
          slot: "joinTime"
        });
      }

      // 中奖时间 - 仅活动类型5和6显示
      if (activityType == 5 || activityType == 6) {
        columns.push({
          label: "中奖时间",
          prop: "winTime",
          width: "210",
          slot: "winTime"
        });
      }

      // 发放时间 - 仅特定活动类型显示
      if (this.fitersChooseIF([16, 17, 18, 19, 27, 28])) {
        columns.push({
          label: "发放时间",
          prop: "grantTime",
          width: "210",
          slot: "grantTime"
        });
      }

      // 状态列 - 根据活动类型显示不同的状态标签
      columns.push({
        label: this.fitersRepurchase([16, 17, 18, 27], '发放状态', '中奖状态'),
        prop: "status",
        width: "130",
        slot: "status"
      });

      // 操作列
      columns.push({
        label: "操作",
        prop: "action",
        slot: "action"
      });

      return columns;
    },
    // 实物奖品名单-表单配置
    initInkindTableColumns() {
      const columns = [];

      // 用户pin（加密）
      columns.push({
        label: "用户pin（加密）",
        prop: "chaosPin",
        width: "150"
      });

      // 用户昵称
      columns.push({
        label: "用户昵称",
        prop: "memberNick",
        width: "180"
      });
      
      // 中奖ID
      columns.push({
        label: "中奖ID",
        prop: "recordId",
        width: "180"
      });

      // 奖品名称
      columns.push({
        label: "奖品名称",
        prop: "prizeTitle",
        width: "180"
      });

      // 商品信息
      columns.push({
        label: "商品信息",
        prop: "goodsInfo",
        width: "300",
        slot: "goodsInfo"
      });

      // 领奖时间/中奖时间
      columns.push({
        label: this.fitersRepurchase([16, 17, 18, 19, 27, 28], '领奖时间', '中奖时间'),
        prop: "sendTime",
        width: "280"
      });

      // 发放状态/中奖状态 - 根据活动类型显示
      if (this.fitersChooseIF([16, 18, 17, 19, 27, 28])) {
        columns.push({
          label: this.fitersChooseIF([16, 18, 17, 27]) ? '发放状态' : '中奖状态',
          prop: "prizeStatus",
          width: "280",
          slot: "prizeStatus"
        });
      }

      // 发货时间
      columns.push({
        label: "发货时间",
        prop: "grantTime",
        width: "280"
      });

      // 发货状态
      columns.push({
        label: "发货状态",
        prop: "grantStatus",
        slot: "grantStatus"
      });

      // 收件人
      columns.push({
        label: "收件人",
        prop: "receiverName",
        slot: "receiverName"
      });

      // 收件人手机号
      columns.push({
        label: "收件人手机号",
        prop: "receiverMobile",
        width: "120",
        slot: "receiverMobile"
      });

      // 收件人地区
      columns.push({
        label: "收件人地区",
        prop: "receiverAddress",
        width: "210",
        slot: "receiverAddress"
      });

      // 收件人详细地址
      columns.push({
        label: "收件人详细地址",
        prop: "detailedAddress",
        width: "210",
        slot: "detailedAddress"
      });

      // 邮编
      columns.push({
        label: "邮编",
        prop: "receiverCode"
      });

      // 快递单号
      columns.push({
        label: "快递单号",
        prop: "billCode"
      });

      // 操作列
      columns.push({
        label: "操作",
        prop: "action",
        width: "280",
        slot: "action"
      });

      return columns;
    },
    // 打榜有礼-实物奖品名单-表格配置
    initGoodsRecordTableColumns() {
      const baseColumns = [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick",
          width: "200"
        }
      ];

      // 根据活动类型添加中奖ID列
      if (this.rowData.activityType == 39) {
        baseColumns.push({
          label: "中奖ID",
          prop: "recordId",
          width: "200"
        });
      }

      // 添加奖品名称列
      baseColumns.push({
        label: "奖品名称",
        prop: "prizeTitle",
        width: "200"
      });

      // 添加姓名列
      baseColumns.push({
        label: "姓名",
        prop: "receiverName",
        width: "150",
        slot: "receiverName"
      });

      // 根据活动类型添加手机号码列
      if (this.rowData.activityType == 39) {
        baseColumns.push({
          label: "手机号码",
          prop: "receiverMobile",
          width: "150",
          slot: "receiverMobile"
        });
      } else {
        baseColumns.push({
          label: "手机号码",
          prop: "mobile",
          width: "150",
          slot: "mobile"
        });
      }

      // 根据活动类型添加地区列
      if (this.rowData.activityType == 39) {
        baseColumns.push({
          label: "地区",
          prop: "receiverAddress",
          width: "200",
          slot: "receiverAddress"
        });
      }

      // 添加详细地址列
      baseColumns.push({
        label: "详细地址",
        prop: "detailedAddress",
        width: "200",
        slot: "detailedAddress"
      });

      // 添加动态列（根据活动类型）
      const dynamicColumns = this.rowData.activityType == 39
        ? [
          { label: "发放时间", prop: "sendTime", width: "200" },
          { label: "发货状态", prop: "statusStr", width: "150" },
          { label: "快递单号", prop: "billCode", width: "200" },
          { label: "发货时间", prop: "grantTime", width: "200" },
        ]
        : [
          { label: "发放时间", prop: "sendTime", width: "200" },
          { label: "中奖状态", prop: "prizeStatus", width: "150" },
          { label: "发货状态", prop: "deliveryStatusStr", width: "150" },
          { label: "快递单号", prop: "billCode", width: "200" },
          { label: "发货时间", prop: "deliveryTime", width: "200" },
        ];
      
      dynamicColumns.forEach(item => {
        // 如果是奖品状态列且不是活动类型39，添加插槽
        if (item.prop === 'prizeStatus' && this.rowData.activityType != 39) {
          item.slot = 'prizeStatus';
        }
        
        baseColumns.push(item);
      });

      // 添加操作列
      baseColumns.push({
        label: "操作",
        prop: "action",
        width: "200",
        slot: "actionGoods"
      });

      return baseColumns;
    },
    // 发放记录-表格配置
    initDistributionTableColumns() {
      const baseColumns = [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick"
        },
        {
          label: "活动名称",
          prop: "activityName"
        }
      ];

      // 根据活动类型添加场景列
      if (this.rowData.activityType == 15) {
        baseColumns.push({
          label: "场景",
          prop: "sceneType",
          slot: "sceneType"
        });
      }

      // 添加其他固定列
      baseColumns.push(
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeType"
        },
        {
          label: "奖品名称",
          prop: "prizeName"
        },
        {
          label: "发放状态",
          prop: "status",
          slot: "status"
        },
        {
          label: "发放时间",
          prop: "joinTime"
        }
      );

      return baseColumns;
    },
    // 拼券明细-表格配置
    initCouponTableColumns() {
      const baseColumns = [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "name"
        }
      ];

      // 根据活动类型添加不同的列
      if (this.fitersChooseIF([21])) {
        baseColumns.push(
          {
            label: "领取时间",
            prop: "grantTime"
          },
          {
            label: "奖励信息",
            prop: "prizeName"
          }
        );
      }

      if (this.fitersChooseIF([31])) {
        baseColumns.push(
          {
            label: "角色",
            prop: "memberRole",
            slot: "memberRole"
          },
          {
            label: "用户身份",
            prop: "memberType",
            slot: "memberType"
          },
          {
            label: "领券时间",
            prop: "grantTime"
          },
          {
            label: "优惠券信息",
            prop: "prizeInfo"
          }
        );
      }

      return baseColumns;
    },
    // 团队详情-表格配置
    initTeamDetailsTableColumns() {
      const baseColumns = [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        }
      ];

      // 根据活动类型添加不同的列
      if (this.fitersChooseIF([21])) {
        baseColumns.push(
          {
            label: "团长",
            prop: "leaderName"
          },
          {
            label: "优惠券",
            prop: "title"
          },
          {
            label: "组团时间",
            prop: "groupTime"
          },
          {
            label: "组团状况",
            prop: "status",
            slot: "teamStatus21"
          }
        );
      }

      if (this.fitersChooseIF([31])) {
        baseColumns.push(
          {
            label: "分享者",
            prop: "leaderName"
          },
          {
            label: "首次分享时间",
            prop: "groupTime"
          },
          {
            label: "拼券状态",
            prop: "status",
            slot: "teamStatus31"
          }
        );
      }

      // 添加操作列
      baseColumns.push({
        label: "组团成员",
        prop: "action",
        slot: "teamAction",
        width: "200"
      });

      return baseColumns;
    },
    // 参与赠送记录-表格配置
    initGiftrecordTableColumns() {
      const baseColumns = [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick"
        },
        {
          label: "获赠类型",
          prop: "taskType",
          slot: "taskType"
        }
      ];

      // 根据活动类型添加不同的列
      if (this.rowData.activityType == 8) {
        baseColumns.push({
          label: "赠送次数",
          prop: "giveTimes",
          slot: "giveTimes"
        });
      }

      baseColumns.push({
        label: "获赠时间",
        prop: "joinTime"
      });

      return baseColumns;
    },
    // 兑换记录-表格配置
    initExchangeTableColumns() {
      const baseColumns = [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick"
        },
        {
          label: "礼品名称",
          prop: "prizeName"
        },
        {
          label: "礼品类型",
          prop: "prizeType",
          width: "100",
          slot: "prizeType"
        },
        {
          label: "消耗积分",
          prop: "point"
        }
      ];

      // 红包专属列（活动类型38）
      if (this.fitersChooseIF([38])) {
        baseColumns.push(
          {
            label: "兑换红包份数",
            prop: "exchangeNum"
          },
          {
            label: "红包金额总数",
            prop: "exchangeTotalAmount"
          }
        );
      }

      baseColumns.push(
        {
          label: "兑换时间",
          prop: "exchangeTime"
        },
        {
          label: "兑换状态",
          prop: "exchangeStatus",
          slot: "exchangeStatus"
        }
      );

      return baseColumns;
    },
    // 邀请统计-表格配置
    initInvitationTableColumns() {
      const baseColumns = [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: "150"
        },
        {
          label: "用户昵称",
          prop: "memberNick"
        }
      ];

      // 根据 isTaskPrize 条件动态添加任务列
      if (this.isTaskPrize) {
        baseColumns.push({
          label: "任务",
          prop: "taskIndex",
          slot: "taskIndex"
        });
      }

      baseColumns.push(
        {
          label: "发起时间",
          prop: "joinTime"
        },
        {
          label: "成功邀请人数",
          prop: "num"
        },
        {
          label: "操作",
          prop: "action",
          slot: "invitationAction"
        }
      );

      return baseColumns;
    },
    // 邀请明细-表格配置
    initCouponMemberTableColumns() {
      const baseColumns = [
        {
          label: "用户昵称",
          prop: "memberNick"
        }
      ];

      // 根据活动类型动态添加列
      if (this.rowData.activityType == 5) {
        baseColumns.push(
          {
            label: "入会状态",
            prop: "isOpenCard",
            slot: "isOpenCard"
          },
          {
            label: "入会时间",
            prop: "openCardTime"
          }
        );
      }

      if (this.rowData.activityType == 6) {
        baseColumns.push({
          label: "关注时间",
          prop: "joinTime"
        });
      }

      return baseColumns;
    },
    // 团队明细-表格配置
    initGroupMemberTableColumns() {
      const baseColumns = [];

      // 根据活动类型动态添加列
      if (this.fitersChooseIF([21])) {
        baseColumns.push(
          {
            label: "成员",
            prop: "name",
            slot: "memberInfo"
          },
          {
            label: "入团时间",
            prop: "joinTime"
          },
          {
            label: "角色",
            prop: "group"
          }
        );
      }

      if (this.fitersChooseIF([31])) {
        baseColumns.push(
          {
            label: "用户昵称",
            prop: "name",
            slot: "memberInfo"
          },
          {
            label: "助力时间",
            prop: "joinTime"
          }
        );
      }

      return baseColumns;
    },
  },
};
</script>
<style lang="scss">
.el-popover {
  min-width: 100px !important;
}
.lock_message_box {
  .el-message-box__content {
    display: flex;
    align-items: center;
    padding: 20px 60px !important;
  }
  .el-message-box__container {
    width: 80px;
    text-align: right;
  }
  .el-message-box__input {
    flex: 1;
    padding-top: 0;
  }
  .el-message-box__errormsg {
    display: none;
  }
}
</style>

<style scoped lang="scss">
.data-title-wrap{
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  .back_text{
    margin-left: 10px;
    color: #2768ff;
    cursor: pointer;
  }
}
// el-table__header-wrapper"
.actName {
  padding: 0px 0 0 24px;
  display: flex;
  &_img {
    width: 60px;
    height: 60px;
  }
  &_info {
    padding-top: 10px;
    div {
      margin-top: 14px;
    }
  }
}
.delivery {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #7b61ff;
  }
}
.backBtn {
  margin-left: 20px;
  width: 98px;
  height: 32px;
  color: #666666;
  border-radius: 3px;
  border: 1px solid #dddddd;
  background-color: #fff;
  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background: rgba(254, 77, 69, 0.1);
  }
  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background: rgba(254, 77, 69, 0.1);
  }
}
.keepBtn {
  width: 98px;
  height: 32px;
  border-radius: 3px;
  background-color: #fe4d45;
  color: #fff;
  &:hover {
    opacity: 0.9;
  }
}
/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }
  .form-box {
    padding-top: 16px;
    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;
      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .item-label2 {
        display: inline-block;
        width: 100px;
        text-align: right;
      }
      .item-value {
        display: inline-block;
      }
    }
  }
  .save-btn {
    text-align: right;
  }
}
.imgurl {
  border-radius: 50%;
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin-right: 7px;
  img {
    width: 80px;
  }
}
.referenceButton {
  cursor: pointer;
  &:hover {
    color: #7b61ff;
  }
}
.referencePopover {
  display: flex;
  span {
    display: block;
    margin-right: 20px;
  }
  span:last-child {
    margin-right: 0px;
  }
}
.decryptHover {
  display: none;
  margin-left: 4px;
  background: none;
}
.decrypt {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}
.decrypt:hover .decryptHover {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background: none;
}

.question_iconOne {
  width: 13px;
  height: 13px;
  display: inline-block;
  line-height: 13px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 4px;
  color: #ccc;
}
.titClass {
  padding: 36px 24px;
  // margin: 35px;
  margin-bottom: 25px;
  background: #fafafa;
  opacity: 1;
  display: flex;
  align-items: center;
  line-height: 22px;
  position: relative;
  .titClassOne {
    margin: 0px 100px 0px 30px;
  }
  .down {
    margin-right: 30px;
  }
  .borderU {
    position: absolute;
    width: 1px;
    height: 110px;
    background: #f3f3f3;
    left: 122px;
  }
}
.acitvityAll {
  background: #fff;
  padding-bottom: 20px;
  border-radius: 8px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      cursor: default;
    }
  }
  .formSty {
    margin: 24px;
    .question_icon {
      width: 15px;
      height: 15px;
      display: inline-block;
      line-height: 12px !important;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #ccc;
      font-size: 14px !important;
      font-weight: normal !important;
      margin-left: 4px;
    }
    .y1,
    .y2,
    .y3,
    .y4 {
      display: inline-block;
      padding: 6px 10px;
      border-radius: 17px;
      margin-right: 5px;
    }
    .y1 {
      color: #5b5b5b;
      background-color: #f1f1f1;
    }
    .y2 {
      color: #02b1ff;
      background: #e6f7ff;
    }
    .y3 {
      color: #f56c6c;
      background-color: #fef0f0;
    }
    .y4 {
      color: #67c23a;
      background-color: #f0f9eb;
    }
    .section-right-content-box {
      // min-width: 1000px;
      // border-bottom: 6px;
      // padding: 15px 28px 30px 28px;
      // background: rgba(255, 255, 255, 1);
      // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      // opacity: 1;
      // -webkit-box-sizing: border-box;
      // -moz-box-sizing: border-box;
      // box-sizing: border-box;
      // margin: 0 20px 20px 20px;
      .tabList {
        display: flex;
        box-sizing: border-box;
        height: 36px;
        line-height: 35px;
        // margin-top: 20px;
        color: #666;
        font-size: 14px;
        margin: 20px 0;
        span {
          margin-right: 3px;
          width: 106px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          vertical-align: middle;
          transform: perspective(1px) translateZ(0);
          box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          border-radius: 2px 2px 0px 0px;
          border: 1px solid #dddddd;
          text-align: center;
        }
        .active {
          position: relative;
          transition: all 0.2s;
          color: #7b61ff;
          border-bottom: none;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            width: 100%;
            top: 0;
            height: 2px;
            background: #7b61ff;
            border-radius: 6px 6px 0px 0px;
          }
        }
        i {
          flex: 1;
          border-bottom: 1px solid #dddddd;
          margin-left: -3px;
        }
      }
      .b1 {
        width: 98px;
        height: 32px;
        color: #fff;
        border: 1px solid #fe4d45;
        background-color: #fe4d45;
        &:hover {
          opacity: 0.8;
        }
      }
      .b2 {
        width: 98px;
        height: 32px;
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff;
        &:hover {
          color: #fff;
          border: 1px solid #fe4d45;
          background-color: #fe4d45;
        }
      }
      .background {
        height: 32px;
        opacity: 1;
        line-height: 32px;
        padding-left: 12px;
        .title {
          display: inline-block;
          width: 2px;
          height: 14px;
          background: #fe4d45;
          opacity: 1;
          border-radius: 3px;
          vertical-align: middle;
        }
        .tips {
          width: 56px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(51, 51, 51, 1);
          opacity: 1;
          vertical-align: middle;
        }
      }

      .overview1 {
        padding: 26px 30px 22px 30px;
        width: 20%;
        height: 100px;
        border-right: 1px solid #f3f3f3;
        opacity: 1;
        margin: 20px 0px;
        .fontClass {
          width: 102px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(102, 102, 102, 1);
          opacity: 1;
        }
        .question_icon {
          width: 14px;
          height: 14px;
          color: #cccccc;
          display: inline-block;
          line-height: 12px;
          text-align: center;
          border-radius: 14px;
          border: 1px solid #cccccc;
          font-size: 12px;
          font-weight: normal;
        }
        .num {
          width: 65px;
          height: 29px;
          font-size: 24px;
          // font-family: DIN;
          font-family: PingFang SC;
          font-weight: bold;
          line-height: 29px;
          color: #1F1F1F;
          opacity: 1;
          margin-top: 14px;
          margin-bottom: 30px;
        }
      }
      /** 打榜有礼 */
      .overview2 {
        padding: 26px 30px 22px 30px;
        width: 18%;
        height: 100px;
        border-right: 1px solid #f3f3f3;
        opacity: 1;
        margin: 20px 0px;
        .fontClass {
          width: 102px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(102, 102, 102, 1);
          opacity: 1;
        }
        .question_icon {
          width: 14px;
          height: 14px;
          color: #cccccc;
          display: inline-block;
          line-height: 12px;
          text-align: center;
          border-radius: 14px;
          border: 1px solid #cccccc;
          font-size: 12px;
          font-weight: normal;
        }
        .num {
          width: 65px;
          height: 29px;
          font-size: 24px;
          // font-family: DIN;
          font-family: PingFang SC;
          font-weight: bold;
          line-height: 29px;
          // color: #2768FF;
          color: #1f1f1f;
          opacity: 1;
          margin-top: 14px;
          margin-bottom: 30px;
        }
      }

      .chart {
        // flex: 1;
        height: 380px;
        min-width: 1100px;
      }
      .chart2 {
        // flex: 1;
        height: 450px;
        min-width: 1100px;
      }
    }
  }
  /deep/ .el-table .two-line {
    height: 40px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

/* 导出数据模态框 */
.sendHug {
  width: 345px;
  height: 30px;
  background: rgba(255, 118, 0, 0.1);
  margin-left: 10px;
  font-size: 14px;
  // font-family: "Microsoft YaHei";
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 118, 0, 1);
}
.hug-send {
  // overflow: hidden;
  margin-top: 10px;
  height: 32px;
  display: flex;
  align-items: center;

  .send-left {
    float: left;
    height: 32px;
    font-size: 14px;
    // font-family: "Microsoft YaHei";
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: rgba(102, 102, 102, 1);
    margin-left: 50px;
  }
  .send-right {
    float: left;
    font-size: 14px;
    // font-family: "Microsoft YaHei";
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 21px;
    color: rgba(51, 51, 51, 1);
    width: 280px;
    height: 100%;
    .send-ipnut {
      display: flex;
      width: 100%;
      height: 32px;
      line-height: 32px;
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      text-indent: 6px;
    }
  }
  .send-right2 {
    height: 32px;
    // border-bottom: 2px solid rgba(245, 245, 245, 1);
  }
  .codeBtn {
    width: 170px;
    display: inline-block;
    line-height: 32px;
    height: 32px;
    font-size: 14px;
    // font-family: "Microsoft YaHei";
    font-family: PingFang SC;
    color: rgba(51, 51, 51, 1);
    outline-style: none;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding-left: 6px;
  }
  .getNumber {
    display: inline-block;
    width: 100px;
    // border: none;
    // background: none;
    outline-style: none;
    color: #7b61ff;
    line-height: 32px;
    color: #fff;
    background: #7b61ff;
    border: 1px solid #7b61ff;
    margin-left: 10px;
    height: 32px;
    border-radius: 4px;
    cursor: pointer;
  }
  .getNumber-Disabled {
    color: rgba(51, 51, 51, 0.2) !important;
    border-color: rgba(51, 51, 51, 0.2) !important;
    cursor: no-drop;
  }
  .msg {
    font-size: 14px;
    // font-family: "Microsoft YaHei";
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 14px;
    color: #7b61ff;
    text-align: center;
  }
}
.dialogExprot-btn {
  width: 100%;
  display: inline-flex;
  justify-content: center;
  > span {
    display: inline-flex;
    width: 98px;
    height: 32px;
    line-height: 32px;
    border: 1px solid #ccc;
    text-align: center;
    font-size: 14px;
    border-radius: 5px;
    margin-right: 8px;
    cursor: pointer;
  }
  > span:nth-of-type(1) {
    background: #7b61ff;
    color: #fff;
    border-color: #7b61ff;
  }
}
.addCartDetail {
  display: flex;
  align-items: center;
  img {
    max-width: 60px;
    border-radius: 5px;
  }
  > div:nth-of-type(1) {
    flex: 1;
  }
  > div:nth-of-type(2) {
    flex: 5;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //设置超出几行省略内容
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.goodsInfo {
  display: flex;
  align-items: center;
  &_logo {
    display: flex;
    width: 80px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 70px;
      border-radius: 4px;
    }
  }
  &_text {
    flex: 1;
    color: #666666;
    cursor: pointer;
    margin-left: 5px;
    a {
      color: #666666;
      margin-top: 5px;
    }
  }
}
.enter_coutier_num_dialog {
  .enter_coutier_num_dialog_floor {
    text-align: right;
    width: 100%;
    // height: 50px;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
}

.physical_batch_shipment_dialog {
  .upload-demo {
    /deep/ .el-upload .el-upload-dragger {
      width: 250px;
    }
  }
  .download_template_box {
    position: absolute;
    right: 24px;
    top: 17%;
  }
  .downloadMsgBox {
    width: 100%;
    min-height: 100px;
  }
  .physical_batch_shipment_dialog_floor {
    text-align: right;
    width: 100%;
    // height: 50px;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
}
.info {
  display: flex;
  align-items: center;
  margin-top: 8px;
  .img-parent {
    margin-right: 8px;
    height: 50px;
    position: relative;
    display: inline-block;
    &:hover {
      cursor: pointer;
      .mask {
        opacity: 1;
      }
    }
    .mask {
      position: absolute;
      opacity: 0;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      // width: 84px;
      // height: 50px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: all 0.3s;
      i {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        color: #fff;
      }
    }
    .info-img  {
      width: 100%;
      height: 50px;
      margin-right: 12px;
    }
  }
}
.bigImg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
  z-index: 99;
  img {
    height: 80%;
  }
  i {
    cursor: pointer;
    margin-top: 12px;
    font-size: 25px;
    color: #fff;
  }
}
.flex-box {
  display: flex;
}
.pt-16 {
  padding-top: 16px;
}

.pl-40 {
  padding-left: 40px;
}

.float-r{
  float: right;
}

.bg-F8F9FA {
  background: #F8F9FA;
}

.export-box {
  background: #F8F9FA;
  display: flex;
  padding-top: 16px;
  align-items: center;
  justify-content: end;
}
.pb-16 {
  padding-bottom: 16px;
}
.penetrate {
  position: relative;
  z-index: 5;
}
.conversion {
  margin-bottom: 15px;
  &-statDaysNum,
  &-compareType,
  &-orderMoney {
    width: 100px;
  }
  &-statType {
    width: 180px;
  }
  &-compareType {
    margin: 0px 10px;
  }
}
</style>
